(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 9536:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(2783);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(3842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(2050);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(9312);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../shared/components/Loader/LoadingPage.tsx
var LoadingPage = __webpack_require__(5302);
// EXTERNAL MODULE: ../shared/providers/auth/index.ts + 124 modules
var auth = __webpack_require__(9487);
// EXTERNAL MODULE: ../node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 8 modules
var useQuery = __webpack_require__(4713);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3444);
// EXTERNAL MODULE: ../node_modules/@chakra-ui/media-query/dist/index.esm.js
var index_esm = __webpack_require__(7020);
// EXTERNAL MODULE: ../node_modules/@chakra-ui/modal/dist/index.esm.js + 58 modules
var dist_index_esm = __webpack_require__(9276);
// EXTERNAL MODULE: ../node_modules/@chakra-ui/layout/dist/index.esm.js + 1 modules
var layout_dist_index_esm = __webpack_require__(5871);
// EXTERNAL MODULE: ../node_modules/@chakra-ui/form-control/dist/index.esm.js
var form_control_dist_index_esm = __webpack_require__(2430);
// EXTERNAL MODULE: ../node_modules/@chakra-ui/input/dist/index.esm.js
var input_dist_index_esm = __webpack_require__(4460);
// EXTERNAL MODULE: ../node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(6411);
// EXTERNAL MODULE: ../shared/lib/src/utils.ts
var utils = __webpack_require__(7718);
// EXTERNAL MODULE: ../models/src/user/index.ts + 16 modules
var src_user = __webpack_require__(9344);
// EXTERNAL MODULE: ../node_modules/axios/index.js + 40 modules
var axios = __webpack_require__(644);
// EXTERNAL MODULE: ../node_modules/jotai/esm/index.mjs + 1 modules
var esm = __webpack_require__(7017);
// EXTERNAL MODULE: ../node_modules/react-hook-form/dist/index.esm.mjs
var react_hook_form_dist_index_esm = __webpack_require__(8039);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/@chakra-ui/icons/dist/index.esm.js
var icons_dist_index_esm = __webpack_require__(9946);
// EXTERNAL MODULE: ../node_modules/@chakra-ui/tag/dist/index.esm.js
var tag_dist_index_esm = __webpack_require__(3006);
// EXTERNAL MODULE: ../node_modules/@chakra-ui/number-input/dist/index.esm.js + 3 modules
var number_input_dist_index_esm = __webpack_require__(9229);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_class_call_check.mjs
var src_class_call_check = __webpack_require__(4364);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(1151);
;// CONCATENATED MODULE: ./models/selected.model.ts


var CURRENCY = "USD";
var CURRENCY_SYMBOL = "$";
var TRANSACTION_FEE_PCT = 0.05;
var SelectedTicket = /*#__PURE__*/ function() {
    "use strict";
    function SelectedTicket(params) {
        (0,src_class_call_check/* default */.Z)(this, SelectedTicket);
        this.ticket = params.ticket;
        this.quantity = params.quantity;
        this.discount = params.discount;
    }
    (0,_create_class/* default */.Z)(SelectedTicket, [
        {
            key: "total",
            get: function get() {
                return this.quantity * this.ticket.currentPrice;
            }
        },
        {
            key: "totalToFixed",
            get: function get() {
                return this.total.toFixed(2);
            }
        },
        {
            key: "payablePerTicket",
            get: function get() {
                var _a;
                return Math.min(this.ticket.currentPrice, ((_a = this.discount) === null || _a === void 0 ? void 0 : _a.price) !== undefined && this.discount.isValid([
                    this.selectedTicketType
                ]) ? this.discount.price : this.ticket.currentPrice);
            }
        },
        {
            key: "payable",
            get: function get() {
                return this.quantity * this.payablePerTicket;
            }
        },
        {
            key: "payableToFixed",
            get: function get() {
                return this.payable.toFixed(2);
            }
        },
        {
            key: "totalDiscount",
            get: function get() {
                var _a;
                return Math.max((((_a = this.discount) === null || _a === void 0 ? void 0 : _a.price) !== undefined && this.discount.isValid([
                    this.selectedTicketType
                ]) ? this.ticket.currentPrice - this.discount.price : 0) * this.quantity, 0);
            }
        },
        {
            key: "totalDiscountToFixed",
            get: function get() {
                return this.totalDiscount.toFixed(2);
            }
        },
        {
            key: "discountTagToFixed",
            get: function get() {
                return this.discountTag.toFixed(0);
            }
        },
        {
            key: "discountTag",
            get: function get() {
                return this.ticket.discount || 0;
            }
        },
        {
            key: "maxQuantity",
            get: function get() {
                if (this.discount && this.discount.remainingUses > 0) {
                    return this.discount.remainingUses;
                }
                // if ([...specialTicketTypes, TicketID.GENERAL].includes(this.ticket.id)) {
                //   return 1;
                // }
                return 10;
            }
        },
        {
            key: "selectedTicketType",
            get: function get() {
                return this.ticket.id;
            }
        },
        {
            key: "freeTicketSelected",
            get: function get() {
                return this.ticket.currentPrice === 0;
            }
        },
        {
            key: "freeTicketWithInvalidDiscount",
            get: function get() {
                return this.freeTicketSelected && !this.discount;
            }
        },
        {
            key: "paypalItems",
            get: function get() {
                var ticket = this.ticket;
                return [
                    {
                        name: ticket.name,
                        quantity: this.quantity.toString(),
                        unit_amount: {
                            currency_code: CURRENCY,
                            value: ticket.currentPrice.toString()
                        },
                        category: "DIGITAL_GOODS",
                        description: ticket.name
                    }, 
                ];
            }
        },
        {
            key: "paypalAmount",
            get: function get() {
                return {
                    currency_code: CURRENCY,
                    value: this.totalPlusTxnFeeToFixed,
                    breakdown: {
                        item_total: {
                            currency_code: CURRENCY,
                            value: this.totalToFixed
                        },
                        discount: {
                            currency_code: CURRENCY,
                            value: this.totalDiscountToFixed
                        },
                        handling: {
                            currency_code: CURRENCY,
                            value: this.transactionFeeToFixed
                        }
                    }
                };
            }
        },
        {
            key: "transactionFee",
            get: function get() {
                return this.payable * TRANSACTION_FEE_PCT;
            }
        },
        {
            key: "transactionFeeToFixed",
            get: function get() {
                return this.transactionFee.toFixed(2);
            }
        },
        {
            key: "transactionFeePct",
            get: function get() {
                return (TRANSACTION_FEE_PCT * 100).toFixed(0);
            }
        },
        {
            key: "totalPlusTxnFee",
            get: function get() {
                return this.payable + this.transactionFee;
            }
        },
        {
            key: "totalPlusTxnFeeToFixed",
            get: function get() {
                return this.totalPlusTxnFee.toFixed(2);
            }
        }
    ]);
    return SelectedTicket;
}();

// EXTERNAL MODULE: ../node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(920);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(6677);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(5963);
;// CONCATENATED MODULE: ./utils/consts/index.ts
var specialTicketTypes = [];

// EXTERNAL MODULE: ../models/src/utils.ts
var src_utils = __webpack_require__(1817);
;// CONCATENATED MODULE: ./utils/mongo/discounts.model.ts



var Discount = /*#__PURE__*/ function() {
    "use strict";
    function Discount(params) {
        (0,src_class_call_check/* default */.Z)(this, Discount);
        this.ticketId = params.ticketId;
        this.price = params.price;
        this.id = params.id || (0,src_utils/* cryptoId */.D6)(4);
        this.usedAt = params.usedAt || 0;
        this.reusable = !!params.reusable;
        this.remainingUses = this.reusable ? -1 : params.remainingUses !== undefined ? params.remainingUses : this.usedAt ? 0 : 1;
    }
    var _proto = Discount.prototype;
    _proto.isValid = function isValid(ticketTypes) {
        var isValid1 = ticketTypes.includes(this.ticketId) && (this.remainingUses > 0 || this.reusable);
        return isValid1;
    };
    _proto.invalidMessage = function invalidMessage(ticketTypes) {
        if (!ticketTypes.includes(this.ticketId)) {
            return "Invalid ticket type";
        }
        if (this.remainingUses === 0 && !this.reusable) {
            return "Discount code has been used";
        }
        return "Invalid discount code";
    };
    (0,_create_class/* default */.Z)(Discount, [
        {
            key: "json",
            get: function get() {
                return (0,src_utils/* toJSON */.au)(this);
            }
        }
    ]);
    return Discount;
}();

;// CONCATENATED MODULE: ./services/api.ts


var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return (0,_instanceof/* default */.Z)(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};


var api = axios/* default.create */.ZP.create({
    baseURL: "/api",
    timeout: 10000,
    headers: {
        "Content-Type": "application/json"
    }
});
var request = function(method, url, params, data, authToken, noData, timeout) {
    return __awaiter(void 0, void 0, void 0, function() {
        var config, ref, err, response, result, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    noData = noData || false;
                    config = {
                        url: url,
                        method: method,
                        params: params,
                        data: data,
                        timeout: timeout
                    };
                    if (authToken) config.headers = {
                        Authorization: "Bearer ".concat(authToken)
                    };
                    return [
                        4,
                        (0,utils.to)(api.request(config))
                    ];
                case 1:
                    ref = _state.sent(), err = ref.err, response = ref.res;
                    // console.log("response", response, "err", err);
                    if (noData) return [
                        2,
                        response
                    ];
                    if (err || !(response === null || response === void 0 ? void 0 : response.data)) throw (err === null || err === void 0 ? void 0 : err.response.data) || err;
                    result = response.data;
                    if (!result.success || result.error || !result.data) throw result.error;
                    return [
                        2,
                        result.data
                    ];
                case 2:
                    error = _state.sent();
                    //console.log(url, method, data, error);
                    console.error("API error", error);
                    return [
                        2,
                        null
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
};
var post = function(url, data, authToken, timeout) {
    return __awaiter(void 0, void 0, void 0, function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                request("POST", url, undefined, data, authToken, false, timeout)
            ];
        });
    });
};
var postNoData = function(url, data, authToken) {
    return __awaiter(void 0, void 0, void 0, function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                request("POST", url, undefined, data, authToken, true)
            ];
        });
    });
};
var get = function(url, params, authToken, noData) {
    return __awaiter(void 0, void 0, void 0, function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                request("GET", url, params, undefined, authToken, noData)
            ];
        });
    });
};
var put = function(url, data, authToken) {
    return __awaiter(void 0, void 0, void 0, function() {
        return _ts_generator(this, function(_state) {
            return [
                2,
                request("PUT", url, undefined, data, authToken)
            ];
        });
    });
};
var del = function(url, authToken) {
    return __awaiter(void 0, void 0, void 0, function() {
        return _ts_generator(this, function(_state) {
            return [
                2,
                request("DELETE", url, undefined, undefined, authToken)
            ];
        });
    });
};

;// CONCATENATED MODULE: ./services/discount.ts


var discount_awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return (0,_instanceof/* default */.Z)(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};





var delayFor = function(seconds) {
    return discount_awaiter(void 0, void 0, void 0, function() {
        return _ts_generator(this, function(_state) {
            return [
                2,
                new Promise(function(resolve) {
                    return setTimeout(resolve, seconds * 1000);
                })
            ];
        });
    });
};
var validateDiscountCode = function(discountId, selectedTicket, setSelectedTicket, tickets) {
    return discount_awaiter(void 0, void 0, void 0, function() {
        var ref, err, data, selectedTicketType, ticketTypes, discount, isValid, ticket, quantity;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!selectedTicket) return [
                        2,
                        false
                    ];
                    if (!discountId) {
                        setSelectedTicket(new SelectedTicket(Object.assign(Object.assign({}, selectedTicket), {
                            discount: undefined
                        })));
                        return [
                            2,
                            false
                        ];
                    }
                    return [
                        4,
                        (0,utils.to)(get("/discounts/".concat(discountId)))
                    ];
                case 1:
                    ref = _state.sent(), err = ref.err, data = ref.res;
                    //await delayFor(1);
                    if (err || !data) {
                        console.log("Error validating discount code", err);
                        setSelectedTicket(new SelectedTicket(Object.assign(Object.assign({}, selectedTicket), {
                            discount: undefined
                        })));
                        return [
                            2,
                            false
                        ];
                    }
                    selectedTicketType = selectedTicket.ticket.id;
                    ticketTypes = specialTicketTypes.includes(selectedTicketType) ? specialTicketTypes : [
                        selectedTicketType
                    ];
                    console.log("get validateDiscountCode:::", data);
                    discount = new Discount(data);
                    isValid = ticketTypes.includes(discount.ticketId) && (discount.remainingUses > 0 || discount.reusable);
                    if (isValid) {
                        ticket = tickets.find(function(t) {
                            return t.id === discount.ticketId;
                        }) || selectedTicket.ticket;
                        quantity = selectedTicket.quantity;
                        if (!discount.reusable) {
                            if (!specialTicketTypes.includes(discount.ticketId)) {
                                quantity = discount.remainingUses;
                            }
                        }
                        setSelectedTicket(new SelectedTicket(Object.assign(Object.assign({}, selectedTicket), {
                            quantity: quantity,
                            discount: discount,
                            ticket: ticket
                        })));
                    } else {
                        setSelectedTicket(new SelectedTicket(Object.assign(Object.assign({}, selectedTicket), {
                            discount: discount
                        })));
                    }
                    //console.log("isValid", isValid);
                    return [
                        2,
                        isValid
                    ];
            }
        });
    });
};
var markDiscount = function(discountId, quantity) {
    return discount_awaiter(void 0, void 0, void 0, function() {
        var ref, err, data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,utils.to)(post("/discounts/mark/".concat(discountId), {
                            quantity: quantity
                        }))
                    ];
                case 1:
                    ref = _state.sent(), err = ref.err, data = ref.res;
                    if (err || !data) return [
                        2,
                        false
                    ];
                    return [
                        2,
                        true
                    ];
            }
        });
    });
};

// EXTERNAL MODULE: ../node_modules/lodash/lodash.js
var lodash = __webpack_require__(8784);
;// CONCATENATED MODULE: ./utils/mongo/tickets.model.ts




var TicketID;
(function(TicketID) {
    TicketID["FULL"] = "astra-full";
    TicketID["CORPORATE"] = "astra-corporate";
    TicketID["FOUNDING"] = "astra-founding";
})(TicketID || (TicketID = {}));
var Ticket = /*#__PURE__*/ function() {
    "use strict";
    function Ticket(params) {
        (0,src_class_call_check/* default */.Z)(this, Ticket);
        this.id = params.id;
        this.defaultPrice = params.defaultPrice;
        this.prices = params.prices || {};
        this.total = params.total;
        this.sold = params.sold || 0;
        this.name = params.name || "";
        this.contractId = params.contractId || "";
        this.displayOrder = params.displayOrder;
        this.uniqueNFT = params.uniqueNFT || 1;
        this.redeemOnly = !!params.redeemOnly;
    }
    (0,_create_class/* default */.Z)(Ticket, [
        {
            key: "json",
            get: function get() {
                return (0,src_utils/* toJSON */.au)(this);
            }
        },
        {
            key: "currentPrice",
            get: function get() {
                if ((0,lodash.isEmpty)(this.prices)) return this.defaultPrice;
                var now = new Date().valueOf();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(this.prices)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var priceId = _step.value;
                        var price = this.prices[priceId];
                        if (price.start <= now && price.end > now) {
                            return price.max ? price.sold < price.max ? price.price : price.fallbackPrice || this.defaultPrice : price.price;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return this.defaultPrice;
            }
        },
        {
            key: "remaining",
            get: function get() {
                var allRemaining = this.total - this.sold;
                if ((0,lodash.isEmpty)(this.prices)) return allRemaining;
                var now = new Date().valueOf();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(this.prices)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var priceId = _step.value;
                        var price = this.prices[priceId];
                        if (price.start <= now && price.end > now) {
                            return price.max ? price.sold < price.max ? price.max - price.sold : allRemaining : allRemaining;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return allRemaining;
            }
        },
        {
            key: "defaultPriceId",
            get: function get() {
                var _this = this;
                return Object.keys(this.prices).find(function(priceId) {
                    return _this.prices[priceId].price === _this.defaultPrice;
                });
            }
        },
        {
            key: "currentPriceId",
            get: function get() {
                if ((0,lodash.isEmpty)(this.prices)) return this.defaultPriceId;
                var now = new Date().valueOf();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(this.prices)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var priceId = _step.value;
                        var price = this.prices[priceId];
                        if (price.start <= now && price.end > now) {
                            return price.max ? price.sold < price.max ? price.id : price.id || this.defaultPriceId : price.id;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return this.defaultPriceId;
            }
        },
        {
            key: "discount",
            get: function get() {
                return this.defaultPrice > this.currentPrice && (this.defaultPrice - this.currentPrice) / this.defaultPrice * 100;
            }
        }
    ]);
    return Ticket;
}();

;// CONCATENATED MODULE: ./tbwDataFunctions/TicketNotes/index.tsx


var returnTicketNotes = function(t) {
    return [
        {
            ticketId: TicketID.FULL,
            note: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-1xl text-neutral-300 "
            })
        },
        {
            ticketId: TicketID.CORPORATE,
            note: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-1xl text-neutral-300",
                    children: "You will need a unique redemption code to claim this membership tier."
                })
            })
        },
        {
            ticketId: TicketID.FOUNDING,
            note: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-1xl text-neutral-300",
                    children: "You will need a unique redemption code to claim this membership tier."
                })
            })
        }, 
    ];
};

;// CONCATENATED MODULE: ./tbwDataFunctions/FaqItems/index.tsx


var returnFaqItems = function(t) {
    return [
        {
            buttonTitle: t("quarantine"),
            panelContent: t("quarantineContent")
        },
        {
            buttonTitle: t("howGetBusinessVisa"),
            panelContent: t("howGetBusinessVisaContent")
        },
        //{
        //  buttonTitle: t("doUHaveSideEvents"),
        //  panelContent: t("doUHaveSideEventsContent"),
        //},
        {
            buttonTitle: t("howCanAccess"),
            panelContent: /*#__PURE__*/ _jsx(_Fragment, {
                children: t.rich("howCanAccessContent", {
                    parent: function(children) {
                        return /*#__PURE__*/ _jsx(OrderedList, {
                            children: children
                        });
                    },
                    item: function(children) {
                        return /*#__PURE__*/ _jsx(ListItem, {
                            children: children
                        });
                    }
                })
            })
        },
        {
            buttonTitle: t("whereIsTicket"),
            panelContent: t("whereIsTicketContent")
        },
        {
            buttonTitle: t("howCanRefund"),
            panelContent: t("howCanRefundContent")
        },
        {
            buttonTitle: t("howCanTransfer"),
            panelContent: t("howCanTransferContent")
        }, 
    ];
};

// EXTERNAL MODULE: ../node_modules/@chakra-ui/icons/node_modules/@chakra-ui/icon/dist/index.esm.js
var icon_dist_index_esm = __webpack_require__(5716);
;// CONCATENATED MODULE: ./components/icons/GlobeIcon.tsx


var GlobeIcon = (0,icon_dist_index_esm/* createIcon */.IU)({
    displayName: "GlobeIcon",
    viewBox: "0 0 24 24",
    path: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        d: "M10 0.322754C4.47702 0.322754 0 4.79977 0 10.3228C0 15.8457 4.47702 20.3228 10 20.3228C15.523 20.3228 20 15.8457 20 10.3228C20 4.79977 15.523 0.322754 10 0.322754ZM13.3181 14.7421C13.1609 14.8986 12.996 15.0627 12.8621 15.1969C12.7415 15.3179 12.6565 15.4671 12.6133 15.6288C12.5524 15.857 12.5032 16.0877 12.421 16.309L11.7198 18.1982C11.1649 18.3191 10.5907 18.3873 10 18.3873V17.2832C10.0681 16.7744 9.69193 15.8211 9.0875 15.2167C8.84556 14.9748 8.70968 14.6465 8.70968 14.3042V13.0135C8.70968 12.5441 8.45685 12.1127 8.04597 11.8857C7.46653 11.5651 6.64234 11.1171 6.07782 10.8328C5.61492 10.5998 5.18669 10.303 4.80161 9.95582L4.76935 9.92679C4.49398 9.67821 4.24948 9.39743 4.04113 9.0905C3.6629 8.53525 3.04677 7.62195 2.64637 7.0284C3.47177 5.19372 4.95927 3.72033 6.80766 2.91993L7.77581 3.40421C8.20484 3.61872 8.70968 3.30703 8.70968 2.82719V2.37154C9.03185 2.31953 9.35968 2.28646 9.69314 2.27396L10.8343 3.41509C11.0863 3.66711 11.0863 4.07558 10.8343 4.32759L10.6452 4.5163L10.2282 4.93324C10.1024 5.05904 10.1024 5.26348 10.2282 5.38929L10.4173 5.5784C10.5431 5.70421 10.5431 5.90864 10.4173 6.03445L10.0948 6.35703C10.0342 6.41748 9.9521 6.45142 9.86653 6.45138H9.50403C9.42016 6.45138 9.33952 6.48404 9.27903 6.54291L8.87903 6.93203C8.83 6.97977 8.79741 7.04187 8.78596 7.10934C8.7745 7.17681 8.78479 7.24618 8.81532 7.30743L9.44395 8.56509C9.55121 8.77961 9.39516 9.03203 9.15564 9.03203H8.92823C8.8504 9.03203 8.7754 9.0038 8.71694 8.953L8.34274 8.628C8.25806 8.55454 8.15572 8.50438 8.04579 8.48246C7.93585 8.46055 7.8221 8.46762 7.71573 8.503L6.45887 8.92195C6.36291 8.95394 6.27946 9.01532 6.22033 9.09739C6.16121 9.17946 6.1294 9.27806 6.12944 9.37921C6.12944 9.56187 6.23266 9.7284 6.39597 9.81025L6.84274 10.0336C7.22218 10.2236 7.64073 10.3224 8.06492 10.3224C8.48911 10.3224 8.97581 11.4228 9.35524 11.6127H12.0468C12.3891 11.6127 12.7169 11.7486 12.9593 11.9905L13.5113 12.5425C13.7419 12.7732 13.8714 13.0861 13.8714 13.4123C13.8713 13.6594 13.8224 13.9042 13.7274 14.1324C13.6325 14.3606 13.4934 14.5678 13.3181 14.7421ZM16.8145 11.0586C16.581 11.0002 16.3774 10.857 16.244 10.6566L15.519 9.56912C15.4129 9.41024 15.3563 9.22348 15.3563 9.03243C15.3563 8.84138 15.4129 8.65462 15.519 8.49574L16.3089 7.31106C16.4024 7.17114 16.5306 7.05743 16.6815 6.98243L17.2048 6.72074C17.75 7.80622 18.0645 9.02719 18.0645 10.3228C18.0645 10.6723 18.0347 11.0147 17.9911 11.3526L16.8145 11.0586Z",
        fill: "#FAFAFB"
    })
});
/* harmony default export */ var icons_GlobeIcon = ((/* unused pure expression or super */ null && (GlobeIcon)));

;// CONCATENATED MODULE: ./public/images/avalanche-icon.svg
/* harmony default export */ var avalanche_icon = ({"src":"/_next/static/media/avalanche-icon.7634d3e1.svg","height":30,"width":31});
;// CONCATENATED MODULE: ./public/images/external-link.svg
/* harmony default export */ var external_link = ({"src":"/_next/static/media/external-link.855f720e.svg","height":34,"width":34});
;// CONCATENATED MODULE: ./public/images/fluent-calendar.svg
/* harmony default export */ var fluent_calendar = ({"src":"/_next/static/media/fluent-calendar.dcda29d2.svg","height":34,"width":34});
;// CONCATENATED MODULE: ./public/images/fluent-location.svg
/* harmony default export */ var fluent_location = ({"src":"/_next/static/media/fluent-location.ca270c20.svg","height":34,"width":34});
;// CONCATENATED MODULE: ./public/images/gcp-icon.svg
/* harmony default export */ var gcp_icon = ({"src":"/_next/static/media/gcp-icon.f5e6fb36.svg","height":24,"width":31});
;// CONCATENATED MODULE: ./public/images/go-arrow.svg
/* harmony default export */ var go_arrow = ({"src":"/_next/static/media/go-arrow.31a1334d.svg","height":24,"width":24});
;// CONCATENATED MODULE: ./public/images/moongate-icon.svg
/* harmony default export */ var moongate_icon = ({"src":"/_next/static/media/moongate-icon.f01d560d.svg","height":30,"width":31});
;// CONCATENATED MODULE: ./public/images/simle-face.svg
/* harmony default export */ var simle_face = ({"src":"/_next/static/media/simle-face.df5cdb35.svg","height":34,"width":34});
;// CONCATENATED MODULE: ./public/images/time.svg
/* harmony default export */ var time = ({"src":"/_next/static/media/time.be5d1f09.svg","height":34,"width":34});
;// CONCATENATED MODULE: ./public/images/public-icon.svg
/* harmony default export */ var public_icon = ({"src":"/_next/static/media/public-icon.1fbb3f14.svg","height":20,"width":22});
;// CONCATENATED MODULE: ./public/images/loading.gif
/* harmony default export */ var images_loading = ({"src":"/_next/static/media/loading.6a0a3fe9.gif","height":800,"width":800});
;// CONCATENATED MODULE: ./components/icons/index.ts
// using chakra craeteIcon func, for chakra Icon component

// using react-icons, for chai Icon component



// using svg file directly, for Nextjs Image component












;// CONCATENATED MODULE: ./components/index.ts


;// CONCATENATED MODULE: ./tbwDataFunctions/InfoItems/index.tsx



var returnInfoItems = function(t) {
    return [
        {
            imgSrc: CalendarIcon,
            imgAlt: "calendar icon",
            text: "February 23rd, 2023 | Doors @ 5:30pm"
        },
        // {
        //   imgSrc: TimeIcon,
        //   imgAlt: "time icon",
        //   text: "February 23rd, 2023 | Doors @ 5:30pm",
        // },
        {
            imgSrc: LocationIcon,
            imgAlt: "location-pin icon",
            text: /*#__PURE__*/ _jsx(_Fragment, {
                children: t.rich("location", {
                    location: function(children) {
                        return /*#__PURE__*/ _jsx("a", {
                            href: "https://goo.gl/maps/ULbVVCNWnFDUPy2U8",
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ _jsx(Text, {
                                as: "u",
                                color: "primary.300",
                                children: children
                            })
                        });
                    }
                })
            })
        },
        {
            imgSrc: SimleFaceIcon,
            imgAlt: "simle-face icon",
            text: /*#__PURE__*/ _jsx(Text, {
                children: t.rich("hostedBy", {
                    buZhiDaoParent: function(children) {
                        return /*#__PURE__*/ _jsx("a", {
                            href: "https://www.avalanchepark.com/",
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ _jsx("span", {
                                className: "text-primary-300 underline",
                                children: children
                            })
                        });
                    }
                })
            })
        },
        {
            imgSrc: PublicIcon,
            imgAlt: "public icon",
            text: "Open for Public"
        },
        {
            imgSrc: ExternalLinkIcon,
            imgAlt: "external-link icon",
            text: /*#__PURE__*/ _jsxs(Text, {
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "mr-5 text-primary-300 underline",
                        children: /*#__PURE__*/ _jsx("a", {
                            href: "https://twitter.com/Ed_Balloon",
                            target: "_blank",
                            rel: "noreferrer",
                            children: "Ed Balloon Twitter"
                        })
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "mr-5 text-primary-300 underline",
                        children: /*#__PURE__*/ _jsx("a", {
                            href: "https://twitter.com/avalancheavax",
                            target: "_blank",
                            rel: "noreferrer",
                            children: "Avalanche Twitter"
                        })
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "mr-5 text-primary-300 underline",
                        children: /*#__PURE__*/ _jsx("a", {
                            href: "https://www.avalanchepark.com/",
                            target: "_blank",
                            rel: "noreferrer",
                            children: t("website")
                        })
                    })
                ]
            })
        }, 
    ];
};

;// CONCATENATED MODULE: ./tbwDataFunctions/index.ts




// EXTERNAL MODULE: ../node_modules/usehooks-ts/dist/esm/index.js + 36 modules
var dist_esm = __webpack_require__(9738);
;// CONCATENATED MODULE: ./utils/misc/index.ts


var transformEmailAddr = function(email) {
    return email.toLowerCase().replace(/\+.*@/g, "@");
};
var showConcatTicketName = function(t, tickets) {
    var _a;
    return tickets.length > 1 ? tickets.map(function(ticket) {
        return t(ticket.id);
    }).join(", ") : t("".concat((_a = tickets[0]) === null || _a === void 0 ? void 0 : _a.id));
};
// concatenate special tickets, return [[normal1], [normal2] [special1, special2] struct
var concatSpecialTicket = function(tickets) {
    var concated = tickets.reduce(function(p, c) {
        return specialTicketTypes.includes(c.id) ? [
            (0,_to_consumable_array/* default */.Z)(p[0]).concat([
                c
            ])
        ].concat((0,_to_consumable_array/* default */.Z)(p.slice(1))) : (0,_to_consumable_array/* default */.Z)(p).concat([
            [
                c
            ]
        ]);
    }, [
        []
    ]);
    concated = concated.filter(function(c) {
        return c.length > 0;
    });
    //console.log("concated:::", concated);
    var sortedConcate = concated.sort(function(a, b) {
        return a[0].displayOrder - b[0].displayOrder;
    });
    return sortedConcate;
};

// EXTERNAL MODULE: ../node_modules/@chakra-ui/radio/dist/index.esm.js
var radio_dist_index_esm = __webpack_require__(3105);
// EXTERNAL MODULE: ../node_modules/@chakra-ui/tooltip/dist/index.esm.js
var tooltip_dist_index_esm = __webpack_require__(3608);
// EXTERNAL MODULE: ../node_modules/@chakra-ui/spinner/dist/index.esm.js
var spinner_dist_index_esm = __webpack_require__(9910);
// EXTERNAL MODULE: ../node_modules/@chakra-ui/hooks/dist/index.esm.js + 2 modules
var hooks_dist_index_esm = __webpack_require__(2718);
// EXTERNAL MODULE: ../node_modules/@chakra-ui/accordion/dist/index.esm.js + 1 modules
var accordion_dist_index_esm = __webpack_require__(9322);
// EXTERNAL MODULE: ../node_modules/@chakra-ui/checkbox/dist/index.esm.js
var checkbox_dist_index_esm = __webpack_require__(6053);
// EXTERNAL MODULE: ../models/src/network.ts
var network = __webpack_require__(9494);
// EXTERNAL MODULE: ../node_modules/next/image.js
var next_image = __webpack_require__(8579);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/Dialog/Dialog.tsx





var Dialog = function(param) {
    var loading = param.loading, icon = param.icon, _iconContainerStyles = param.iconContainerStyles, iconContainerStyles = _iconContainerStyles === void 0 ? "w-8 mb-4" : _iconContainerStyles, title = param.title, _titleStyles = param.titleStyles, titleStyles = _titleStyles === void 0 ? "w-5/6 text-center" : _titleStyles, children = param.children, isOpen = param.isOpen, onOpen = param.onOpen, onClose = param.onClose, actions = param.actions, size = param.size, minH = param.minH, contentJustifyContent = param.contentJustifyContent;
    var ref = (0,_sliced_to_array/* default */.Z)((0,index_esm/* useMediaQuery */.ac)("(max-width: 640px)"), 1), isMobile = ref[0];
    size = isMobile ? "full" : size || "md";
    isOpen = isOpen !== null && isOpen !== void 0 ? isOpen : true;
    onClose = onClose !== null && onClose !== void 0 ? onClose : function() {};
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Modal */.u_, {
        onClose: onClose,
        isOpen: isOpen,
        isCentered: true,
        size: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* ModalOverlay */.ZA, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* ModalContent */.hz, {
                minH: minH || {},
                justifyContent: contentJustifyContent || {},
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* ModalHeader */.xB, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col content-center items-center",
                            children: [
                                loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: images_loading,
                                        layout: "responsive",
                                        alt: ""
                                    })
                                }) : "",
                                icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: iconContainerStyles,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: icon,
                                        layout: "responsive",
                                        alt: ""
                                    })
                                }) : "",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: titleStyles,
                                    children: title
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* ModalCloseButton */.ol, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* ModalBody */.fe, {
                        flexGrow: "0",
                        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "flex flex-row justify-center font-medium text-lg mb-4",
                                    children: "Loading..."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-center",
                                    children: children
                                })
                            ]
                        }) : children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* ModalFooter */.mz, {
                        children: actions && actions.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* ButtonGroup */.hE, {
                            variant: "ghost",
                            className: "self-end",
                            spacing: "4",
                            children: actions.map(function(action, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                    color: action.primary ? "primary.300" : action.error ? "white" : "neutral.200",
                                    variant: action.variant || {},
                                    onClick: action.onClick,
                                    fontSize: "0.9em",
                                    bgColor: action.bgColor || {},
                                    children: action.text
                                }, i);
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Dialog_Dialog = (Dialog);

;// CONCATENATED MODULE: ./public/images/ic-blurred-bg-filled-red-cross.svg
/* harmony default export */ var ic_blurred_bg_filled_red_cross = ({"src":"/_next/static/media/ic-blurred-bg-filled-red-cross.a0365deb.svg","height":110,"width":111});
;// CONCATENATED MODULE: ./services/email.ts


var email_awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return (0,_instanceof/* default */.Z)(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};


var sendEmailForTransaction = function(transaction) {
    return email_awaiter(void 0, void 0, void 0, function() {
        var ref, err, data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,utils.to)(postNoData("/emails/send", {
                            transaction: transaction
                        }))
                    ];
                case 1:
                    ref = _state.sent(), err = ref.err, data = ref.res;
                    if (err || !data) return [
                        2,
                        false
                    ];
                    return [
                        2,
                        true
                    ];
            }
        });
    });
};

// EXTERNAL MODULE: ../models/src/base.ts
var base = __webpack_require__(242);
;// CONCATENATED MODULE: ../models/src/job/job.ts




var job_JobName;
(function(JobName) {
    JobName["AIRDROP_NFT"] = "airdrop_nft";
})(job_JobName || (job_JobName = {}));
var JobStatus;
(function(JobStatus) {
    JobStatus["CREATED"] = "created";
    JobStatus["PENDING"] = "pending";
    JobStatus["IN_PROGRESS"] = "in_progress";
    JobStatus["COMPLETED"] = "completed";
    JobStatus["FAILED"] = "failed";
})(JobStatus || (JobStatus = {}));
var job_JobBase = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(Base) {
    "use strict";
    _inherits(JobBase, Base);
    var _super = _create_super(JobBase);
    function JobBase(params) {
        _class_call_check(this, JobBase);
        var _this;
        _this = _super.call(this, params);
        _this.name = params.name;
        _this.refIds = params.refIds || [];
        _this.status = params.status || JobStatus.CREATED;
        if (params.data) _this.data = params.data;
        if (params.result) _this.result = params.result;
        if (params.error) _this.error = params.error;
        return _this;
    }
    return JobBase;
}(Base)));

;// CONCATENATED MODULE: ../models/src/job/airdrop.ts





var AirdropJob = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(JobBase) {
    "use strict";
    _inherits(AirdropJob, JobBase);
    var _super = _create_super(AirdropJob);
    function AirdropJob(params) {
        _class_call_check(this, AirdropJob);
        var _this;
        _this = _super.call(this, Object.assign(Object.assign({}, params), {
            name: JobName.AIRDROP_NFT
        }));
        _this.code = params.code || cryptoId(4);
        _this.data = params.data;
        return _this;
    }
    return AirdropJob;
}(JobBase)));

;// CONCATENATED MODULE: ../models/src/job/index.ts



;// CONCATENATED MODULE: ./services/nft.ts


var nft_awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return (0,_instanceof/* default */.Z)(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};






var mintNFT = function(recipient, transaction) {
    return nft_awaiter(void 0, void 0, void 0, function() {
        var _a, ref, ticket, contractId, ref1, contract, template, contactInfos, jobIds, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, contactInfo, ref2, transfers, ref3, _$err, user, jobId, user_, walletAddress, _recipient, ref4, _$err1, job, ref5, _$err2, job1, err, ref6, _$err3, data, err1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    console.log("mintNFT:::", transaction);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        19,
                        ,
                        20
                    ]);
                    if (!transaction.contactInfos || transaction.contactInfos.length === 0) throw "transactions's contactInfos not found";
                    return [
                        4,
                        (0,utils.to)(get("/tickets/".concat(transaction.ticketId)))
                    ];
                case 2:
                    ref = _state.sent(), ticket = ref.res;
                    if (!ticket) throw "ticket not found";
                    contractId = ticket.contractId;
                    console.log("contractId:::", contractId);
                    if (!contractId) throw "ticket's contractId not found";
                    return [
                        4,
                        (0,utils.to)(get("/contracts/".concat(contractId)))
                    ];
                case 3:
                    ref1 = _state.sent(), contract = ref1.res;
                    if (!contract) throw "contract of ".concat(contractId, " not found");
                    console.log("contract:::", contract);
                    template = transaction.templateId;
                    console.log("template:::", template);
                    contactInfos = transaction.contactInfos || [];
                    jobIds = [];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        15,
                        16,
                        17
                    ]);
                    _iterator = contactInfos[Symbol.iterator]();
                    _state.label = 5;
                case 5:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        14
                    ];
                    contactInfo = _step.value;
                    if (!(ticket.uniqueNFT !== 1)) return [
                        3,
                        7
                    ];
                    return [
                        4,
                        (0,utils.to)(get("/nfts/transfers/".concat(contract.network, "/").concat(contract.address)))
                    ];
                case 6:
                    ref2 = _state.sent(), transfers = ref2.res;
                    console.log("transfer:::", transfers);
                    template = "".concat(template, "-").concat(transfers.length % ticket.uniqueNFT);
                    _state.label = 7;
                case 7:
                    console.log("template:::", template);
                    return [
                        4,
                        (0,utils.to)(get("/users/user/".concat(contactInfo.emailAddress)))
                    ];
                case 8:
                    ref3 = _state.sent(), _$err = ref3.err, user = ref3.res;
                    if (_$err) console.error("mintNFT:::get user err", _$err);
                    jobId = "";
                    if (!user) return [
                        3,
                        10
                    ];
                    user_ = new src_user/* User */.n5(user);
                    //console.log("mintNFT:::user", user_);
                    //
                    console.log("mintNFT:::user", user_);
                    walletAddress = (_a = user_.wallets.find(function(w) {
                        return network/* EVM_NETWORKS.includes */.uV.includes(w.network);
                    })) === null || _a === void 0 ? void 0 : _a.address;
                    console.log("mintNFT:::user wallet", walletAddress);
                    console.log("recipient:::", recipient);
                    _recipient = recipient || walletAddress;
                    if (!_recipient) {
                        console.log("mintNFT:::user wallet not found");
                        return [
                            3,
                            13
                        ];
                    }
                    console.log("mintNFT:::_recipient", _recipient);
                    return [
                        4,
                        (0,utils.to)(post("/nfts/".concat(contractId, "/airdrop"), {
                            recipient: _recipient,
                            template: template
                        }))
                    ];
                case 9:
                    ref4 = _state.sent(), _$err1 = ref4.err, job = ref4.res;
                    if (_$err1 || !job) console.error("mintNFT:::airdrop err", _$err1);
                    //console.log("mintNFT:::airdrop data", job);
                    jobId = job.jobId || "";
                    return [
                        3,
                        12
                    ];
                case 10:
                    return [
                        4,
                        (0,utils.to)(post("/jobs", {
                            name: job_JobName.AIRDROP_NFT,
                            status: JobStatus.PENDING,
                            data: {
                                identifier: transformEmailAddr(contactInfo.emailAddress),
                                metadataTemplateId: template,
                                contractId: contractId
                            }
                        }))
                    ];
                case 11:
                    ref5 = _state.sent(), _$err2 = ref5.err, job1 = ref5.res;
                    if (_$err2 || !job1) return [
                        2,
                        console.error("mintNFT:::err", _$err2)
                    ];
                    //console.log("mintNFT:::post job data", job);
                    jobId = job1.jobId || "";
                    _state.label = 12;
                case 12:
                    jobIds.push(jobId);
                    _state.label = 13;
                case 13:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        5
                    ];
                case 14:
                    return [
                        3,
                        17
                    ];
                case 15:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        17
                    ];
                case 16:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 17:
                    return [
                        4,
                        (0,utils.to)(post("/transactions/mark/".concat(transaction.id), {
                            jobIds: jobIds
                        }))
                    ];
                case 18:
                    ref6 = _state.sent(), _$err3 = ref6.err, data = ref6.res;
                    if (_$err3 || !data) return [
                        2,
                        console.error("mintNFT:::err", _$err3)
                    ];
                    //console.log("mintNFT:::data", data);
                    return [
                        2,
                        true
                    ];
                case 19:
                    err1 = _state.sent();
                    console.error(err1);
                    return [
                        2,
                        false
                    ];
                case 20:
                    return [
                        2
                    ];
            }
        });
    });
};

;// CONCATENATED MODULE: ./services/ticket.ts


var ticket_awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return (0,_instanceof/* default */.Z)(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};



var getTickets = function() {
    return ticket_awaiter(void 0, void 0, void 0, function() {
        var _tickets, tickets;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        get("/tickets/all")
                    ];
                case 1:
                    _tickets = _state.sent();
                    if (!_tickets) return [
                        2,
                        []
                    ];
                    tickets = _tickets.map(function(t) {
                        return new Ticket(t);
                    });
                    //useTicketStore.setState({ events });
                    return [
                        2,
                        tickets.sort(function(a, b) {
                            return a.displayOrder - b.displayOrder;
                        })
                    ];
            }
        });
    //return tickets;
    });
};
var markTicket = function(ticket, quantity) {
    return ticket_awaiter(void 0, void 0, void 0, function() {
        var ref, err, data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,utils.to)(post("/tickets/mark/".concat(ticket.id), {
                            quantity: quantity,
                            priceId: ticket.currentPriceId
                        }))
                    ];
                case 1:
                    ref = _state.sent(), err = ref.err, data = ref.res;
                    if (err || !data) return [
                        2,
                        false
                    ];
                    return [
                        2,
                        true
                    ];
            }
        });
    });
};

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(7599);
;// CONCATENATED MODULE: ./services/transaction.ts



var transaction_awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return (0,_instanceof/* default */.Z)(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};


var createTransaction = function(captureStatus, values, customId, invoiceId, selectedTicket, user, lang) {
    return transaction_awaiter(void 0, void 0, void 0, function() {
        var _a, contactInfos, ticket, ref, err, data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    console.log(values);
                    contactInfos = Object.keys(values).filter(function(v) {
                        return v !== "agreement";
                    }).reduce(function(acc, curr) {
                        var i = curr.split("-")[0];
                        var input = curr.split("-")[1];
                        if (!input) return acc;
                        var value = values[curr];
                        var index = acc.findIndex(function(v) {
                            return v["id"] === i;
                        });
                        if (index < 0) {
                            acc.push((0,_define_property/* default */.Z)({
                                id: i
                            }, input, value));
                        } else {
                            acc[index][input] = value;
                        }
                        return acc;
                    }, []);
                    ticket = selectedTicket.ticket;
                    return [
                        4,
                        (0,utils.to)(post("/transactions/create", {
                            id: customId,
                            ticketId: ticket.id,
                            emails: contactInfos.map(function(c) {
                                return c.emailAddress;
                            }),
                            discountCodeId: ((_a = selectedTicket.discount) === null || _a === void 0 ? void 0 : _a.id) || null,
                            refIds: {
                                invoiceId: invoiceId
                            },
                            contactInfos: contactInfos,
                            price: selectedTicket.payablePerTicket,
                            captureStatus: captureStatus,
                            buyer: user.email,
                            walletAddress: values.walletAddress || user.walletAddresses[0],
                            locale: lang,
                            priceId: ticket.currentPriceId,
                            userId: user.id,
                            quantity: selectedTicket.quantity
                        }))
                    ];
                case 1:
                    ref = _state.sent(), err = ref.err, data = ref.res;
                    if (err || !data) {
                        return [
                            2,
                            [
                                false,
                                null
                            ]
                        ];
                    }
                    return [
                        2,
                        [
                            true,
                            data
                        ]
                    ];
            }
        });
    });
};
var getTransactionByEmail = function(email) {
    return transaction_awaiter(void 0, void 0, void 0, function() {
        var ref, err, data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,utils.to)(get("/transactions/all?email=".concat(email)))
                    ];
                case 1:
                    ref = _state.sent(), err = ref.err, data = ref.res;
                    if (err || !data) return [
                        2,
                        []
                    ];
                    return [
                        2,
                        data
                    ];
            }
        });
    });
};
var _transformEmailAddr = function(email) {
    return email.toLowerCase().replace(/\+.*@/g, "@");
};
var hasTransactionByEmail = function(email) {
    return transaction_awaiter(void 0, void 0, void 0, function() {
        var ref, err, data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (email.length === 0) {
                        return [
                            2,
                            false
                        ];
                    }
                    return [
                        4,
                        (0,utils.to)(getTransactionByEmail(_transformEmailAddr(email)))
                    ];
                case 1:
                    ref = _state.sent(), err = ref.err, data = ref.res;
                    if (err || !data) return [
                        2,
                        false
                    ];
                    return [
                        2,
                        data.length === 0
                    ];
            }
        });
    });
};
var updateTransactionStatusByCustomId = function(customId, captureStatus, error) {
    return transaction_awaiter(void 0, void 0, void 0, function() {
        var ref, err, data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    console.log("updateTransactionStatusByCustomId error:", error);
                    return [
                        4,
                        (0,utils.to)(post("/transactions/".concat(customId), {
                            captureStatus: captureStatus,
                            errorMessage: error
                        }))
                    ];
                case 1:
                    ref = _state.sent(), err = ref.err, data = ref.res;
                    if (err || !data) return [
                        2,
                        false
                    ];
                    return [
                        2,
                        true
                    ];
            }
        });
    });
};

;// CONCATENATED MODULE: ./utils/mongo/transactions.model.ts



var PaypalTransactionCaptureStatus;
(function(PaypalTransactionCaptureStatus) {
    PaypalTransactionCaptureStatus["COMPLETED"] = "COMPLETED";
    PaypalTransactionCaptureStatus["DENIED"] = "DENIED";
    PaypalTransactionCaptureStatus["PENDING"] = "PENDING";
    PaypalTransactionCaptureStatus["REFUNDED"] = "REFUNDED";
    PaypalTransactionCaptureStatus["REVERSED"] = "REVERSED";
    PaypalTransactionCaptureStatus["WAIVED"] = "WAIVED";
    PaypalTransactionCaptureStatus["INITIATED"] = "INITIATED";
    PaypalTransactionCaptureStatus["APPROVED"] = "APPROVED";
    PaypalTransactionCaptureStatus["CANCELLED"] = "CANCELLED";
    PaypalTransactionCaptureStatus["FAILED"] = "FAILED";
})(PaypalTransactionCaptureStatus || (PaypalTransactionCaptureStatus = {}));
var PaypalTransaction = /*#__PURE__*/ function() {
    "use strict";
    function PaypalTransaction(params) {
        (0,src_class_call_check/* default */.Z)(this, PaypalTransaction);
        this.id = params === null || params === void 0 ? void 0 : params.id;
        this.ticketId = params === null || params === void 0 ? void 0 : params.ticketId;
        this.priceId = params === null || params === void 0 ? void 0 : params.priceId;
        this.price = (params === null || params === void 0 ? void 0 : params.price) || 0;
        this.captureStatus = (params === null || params === void 0 ? void 0 : params.captureStatus) || PaypalTransactionCaptureStatus.INITIATED;
        this.refIds = (params === null || params === void 0 ? void 0 : params.refIds) || {};
        this.contactInfos = (params === null || params === void 0 ? void 0 : params.contactInfos) || [];
        this.emails = (params === null || params === void 0 ? void 0 : params.emails) || [];
        this.discountCodeId = (params === null || params === void 0 ? void 0 : params.discountCodeId) || "";
        this.createdAt = (params === null || params === void 0 ? void 0 : params.createdAt) || new Date().valueOf();
        this.updatedAt = (params === null || params === void 0 ? void 0 : params.updatedAt) || new Date().valueOf();
        this.quantity = (params === null || params === void 0 ? void 0 : params.quantity) || this.contactInfos.length;
        this.buyer = (params === null || params === void 0 ? void 0 : params.buyer) || "";
        this.walletAddress = (params === null || params === void 0 ? void 0 : params.walletAddress) || "";
        this.locale = (params === null || params === void 0 ? void 0 : params.locale) || "en";
        this.userId = params === null || params === void 0 ? void 0 : params.userId;
    }
    (0,_create_class/* default */.Z)(PaypalTransaction, [
        {
            key: "json",
            get: function get() {
                return (0,src_utils/* toJSON */.au)(this);
            }
        },
        {
            key: "templateId",
            get: function get() {
                return this.ticketId;
            }
        },
        {
            key: "buyerBuysForOneself",
            get: function get() {
                return this.contactInfos && this.contactInfos.length > 0 && this.contactInfos[0].emailAddress === this.buyer;
            }
        },
        {
            key: "buyerBuysForOthersOnly",
            get: function get() {
                return this.contactInfos && this.contactInfos.length > 0 && this.contactInfos[0].emailAddress !== this.buyer;
            }
        }
    ]);
    return PaypalTransaction;
}();

// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(7632);
;// CONCATENATED MODULE: ./public/images/fluent-error-circle.svg
/* harmony default export */ var fluent_error_circle = ({"src":"/_next/static/media/fluent-error-circle.ce0e8948.svg","height":34,"width":34});
;// CONCATENATED MODULE: ./components/TicketingModal/CheckoutModal/ContactInformation.tsx















var FormControlWrapper = function(param) {
    var label = param.label, inputName = param.inputName, placeholder = param.placeholder, required = param.required, register = param.register, errors = param.errors, attendee = param.attendee, watch = param.watch, userEmailFirstTime = param.userEmailFirstTime, user = param.user, trigger = param.trigger, span = param.span;
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,index_esm/* useMediaQuery */.ac)("(max-width: 640px)"), 1), isMobile = ref1[0];
    var t = (0,next_intl_cjs_production_min.useTranslations)("checkout");
    var inputName_ = "".concat(attendee, "-").concat(inputName);
    var disabledFirstEmailInput = userEmailFirstTime && (inputName_ === "0-emailAddress" || inputName_ === "0-confirmEmailAddress");
    var b = userEmailFirstTime ? inputName_ !== "0-emailAddress" : true;
    var b_ = userEmailFirstTime ? inputName_ !== "0-confirmEmailAddress" : true;
    var checkDuplicate = function(v, inputName) {
        var allSameInputs = Object.keys(watch()).filter(function(x) {
            return x.match(new RegExp("[0-9]+-".concat(inputName), "g"));
        });
        var otherSameInputs = allSameInputs.filter(function(x) {
            return x !== inputName_;
        });
        return !otherSameInputs.map(function(i) {
            return watch()[i];
        }).includes(transformEmailAddr(v));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_control_dist_index_esm/* FormControl */.NI, {
        isInvalid: Boolean(errors[inputName_]),
        style: {
            gridColumn: isMobile ? "span 1" : "span ".concat(span)
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormLabel */.lX, {
                htmlFor: inputName_,
                variant: "custom",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                label,
                                " "
                            ]
                        }),
                        required && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-primary-300",
                            children: "*"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, (0,_object_spread/* default */.Z)({
                type: "text",
                //isDisabled={disabledFirstEmailInput}
                readOnly: disabledFirstEmailInput,
                //value={disabledFirstEmailInput ? user?.email : undefined}
                placeholder: placeholder,
                _placeholder: {
                    opacity: 0.3
                }
            }, register(inputName_, {
                required: required && "".concat(label, " ").concat(t("required")),
                pattern: inputName === "emailAddress" && {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: t("invalidEmail")
                },
                validate: inputName === "emailAddress" && b && {
                    noDuplicate: function(v) {
                        return checkDuplicate(v, inputName) || t("duplicateEmail");
                    },
                    checkEmail: function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(v) {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            hasTransactionByEmail(v)
                                        ];
                                    case 1:
                                        return [
                                            2,
                                            _state.sent() || t("emailPurchased")
                                        ];
                                }
                            });
                        });
                        return function(v) {
                            return _ref.apply(this, arguments);
                        };
                    }()
                } || inputName === "confirmEmailAddress" && b_ && {
                    confirmEmail: function(v) {
                        return v === watch("".concat(attendee, "-emailAddress")) || t("emailMismatch");
                    }
                },
                onChange: (0,lodash.debounce)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    trigger(inputName_)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }), 1000)
            }))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormErrorMessage */.J1, {
                children: (ref = errors[inputName_]) === null || ref === void 0 ? void 0 : ref.message
            })
        ]
    });
};
var AccordionItemWrapper = function(param) {
    var buttonTitle = param.buttonTitle, children = param.children, isLast = param.isLast, attendee = param.attendee, errors = param.errors;
    var hasError = Object.keys(errors).filter(function(x) {
        return x.match(new RegExp("".concat(attendee, "+-.*"), "g"));
    }).length > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(accordion_dist_index_esm/* AccordionItem */.Qd, {
        borderTop: 0,
        _last: {
            borderBottom: "0"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(accordion_dist_index_esm/* AccordionButton */.KF, {
                    _hover: {
                    },
                    bg: "neutral.900",
                    px: "1.25rem",
                    borderTopRadius: !!attendee ? "" : "0.5rem",
                    borderWidth: "2px",
                    borderColor: hasError ? "red.500" : "#DEDEE0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                            fontWeight: 500,
                            fontSize: "lg",
                            color: "neutral.300",
                            flex: "1",
                            textAlign: "left",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                fontSize: "2xl",
                                fontWeight: 500,
                                my: "0.5rem",
                                children: buttonTitle
                            })
                        }),
                        hasError && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-10 mr-5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                layout: "responsive",
                                src: fluent_error_circle,
                                alt: "error icon"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_dist_index_esm/* AccordionIcon */.XE, {
                            width: "2rem",
                            fontSize: "2rem",
                            color: "neutral.300"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_dist_index_esm/* AccordionPanel */.Hk, {
                borderWidth: "2px",
                borderColor: hasError ? "red.500" : "#DEDEE0",
                borderTop: 0,
                px: "1.25rem",
                py: "2.5rem",
                borderBottomRadius: isLast ? "0.5rem" : "",
                children: children
            })
        ]
    });
};
var ContactInformation = function(param) {
    var attendee = param.attendee, register = param.register, errors = param.errors, selectedTicketType = param.selectedTicketType, //validateEmail,
    watch = param.watch, isLast = param.isLast, userEmailFirstTime = param.userEmailFirstTime, user = param.user, trigger = param.trigger;
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(languageAtom), 1), lang = ref[0];
    var t = (0,next_intl_cjs_production_min.useTranslations)("checkout");
    var inputList = [
        {
            label: t("emailAddress"),
            inputName: "emailAddress",
            placeholder: "john@gmail.com",
            required: true
        },
        {
            label: t("confirmEmailAddress"),
            inputName: "confirmEmailAddress",
            placeholder: "john@gmail.com",
            required: true
        },
        {
            label: "Name",
            inputName: "name",
            placeholder: "",
            required: true,
            span: 2
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionItemWrapper, {
            //buttonTitle={`${t("ticket")} ${attendee + 1}`}
            buttonTitle: "Member Details",
            isLast: isLast,
            attendee: attendee,
            errors: errors,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-8",
                children: inputList.map(function(input, index) {
                    var ref;
                    return (!input.onlyForTicketType || ((ref = input.onlyForTicketType) === null || ref === void 0 ? void 0 : ref.includes(selectedTicketType))) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, input), {
                        register: register,
                        errors: errors,
                        attendee: attendee,
                        //validateEmail={validateEmail}
                        watch: watch,
                        userEmailFirstTime: userEmailFirstTime,
                        user: user,
                        trigger: trigger
                    }), index);
                })
            })
        })
    });
};
/* harmony default export */ var CheckoutModal_ContactInformation = (ContactInformation);

;// CONCATENATED MODULE: ./components/TicketingModal/TicketingModalExpandableButton.tsx






var TicketingModalExpandableButton = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(selectedTicketAtom), 1), selectedTicket = ref[0];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(orderSummaryOpenAtom), 2), setOrderSummaryOpen = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "md:hidden py-0 sm:py-4",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_dist_index_esm/* Button */.zx, {
            fontSize: "lg",
            px: "1.5rem",
            //py="0.70rem"
            color: "white",
            backgroundColor: "transparent",
            fontWeight: "bold",
            borderRadius: "6.25rem",
            variant: "transparent",
            onClick: function() {
                return setOrderSummaryOpen(true);
            },
            disabled: !selectedTicket,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "transition-opacity duration-500 ".concat(!selectedTicket && "opacity-0"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_dist_index_esm/* ChevronUpIcon */.g8, {
                        w: 30,
                        h: 30
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Text */.xv, {
                    ml: 1,
                    children: [
                        "$ ",
                        selectedTicket ? selectedTicket.payableToFixed : "0.00"
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var TicketingModal_TicketingModalExpandableButton = (TicketingModalExpandableButton);

// EXTERNAL MODULE: ../node_modules/@paypal/react-paypal-js/dist/esm/react-paypal-js.js
var react_paypal_js = __webpack_require__(1296);
;// CONCATENATED MODULE: ./components/PayPalButtonWrapper/PayPalButtonWrapper.tsx














var PayPalButtonWrapper = function(param) {
    var _disabled = param.disabled, disabled = _disabled === void 0 ? true : _disabled, _items = param.items, items = _items === void 0 ? [] : _items, _amount = param.amount, amount = _amount === void 0 ? {} : _amount, invoiceId = param.invoiceId, customId = param.customId, _beforeCreateOrder = param.beforeCreateOrder, beforeCreateOrder = _beforeCreateOrder === void 0 ? /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        new Promise(function(resolve) {
                            return setTimeout(resolve, 5000);
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        false
                    ];
            }
        });
    }) : _beforeCreateOrder;
    var ref = (0,_sliced_to_array/* default */.Z)((0,react_paypal_js/* usePayPalScriptReducer */.Up)(), 1), isPending = ref[0].isPending;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(selectedTicketAtom), 1), selectedTicket = ref1[0];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(successAtom), 2), setSuccess = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(openPaymentErrorModalAtom), 2), setOpenPaymentErrorModal = ref3[1];
    var paypalRef = (0,react.useRef)(null);
    var paypalCallback = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(status, data) {
            var err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(status === "approve")) return [
                            3,
                            5
                        ];
                        if (!selectedTicket) return [
                            2,
                            console.error("No selected ticket")
                        ];
                        if (!selectedTicket.discount) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            markDiscount(selectedTicket.discount.id, selectedTicket.quantity)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        // update sold tickets
                        return [
                            4,
                            markTicket(selectedTicket.ticket, selectedTicket.quantity)
                        ];
                    case 3:
                        _state.sent();
                        // update transaction status as approved
                        return [
                            4,
                            updateTransactionStatusByCustomId(customId, PaypalTransactionCaptureStatus.APPROVED)
                        ];
                    case 4:
                        _state.sent();
                        setSuccess(true);
                        return [
                            3,
                            11
                        ];
                    case 5:
                        if (!(status === "cancel")) return [
                            3,
                            7
                        ];
                        console.error("".concat(status, " during paypal transaction"));
                        // await deleteTransactionByCustomId(customId); // don't delete transaction in order to trace it
                        return [
                            4,
                            updateTransactionStatusByCustomId(customId, PaypalTransactionCaptureStatus.CANCELLED, data)
                        ];
                    case 6:
                        _state.sent();
                        setOpenPaymentErrorModal(true);
                        return [
                            3,
                            11
                        ];
                    case 7:
                        if (!(status === "error")) return [
                            3,
                            9
                        ];
                        console.log("error data:::", data.name, data.message);
                        console.log("error data:::", String(data));
                        err = {};
                        err["error"] = data;
                        console.log("error json data:::", JSON.stringify(err));
                        return [
                            4,
                            updateTransactionStatusByCustomId(customId, PaypalTransactionCaptureStatus.FAILED, String(data))
                        ];
                    case 8:
                        _state.sent();
                        setOpenPaymentErrorModal(true);
                        return [
                            3,
                            11
                        ];
                    case 9:
                        console.error("Unknown status during paypal transaction, status:::", status);
                        return [
                            4,
                            updateTransactionStatusByCustomId(customId, PaypalTransactionCaptureStatus.FAILED, data)
                        ];
                    case 10:
                        _state.sent();
                        setOpenPaymentErrorModal(true);
                        _state.label = 11;
                    case 11:
                        return [
                            2
                        ];
                }
            });
        });
        return function paypalCallback(status, data) {
            return _ref.apply(this, arguments);
        };
    }();
    // doesn't work
    // -> https://stackoverflow.com/questions/43276570/trigger-paypal-checkout-button-click
    //const handleClick = (e) => {
    //  e.preventDefault();
    //  (paypalRef.current as any).click();
    //};
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            isPending ? /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner_dist_index_esm/* Spinner */.$, {}) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    colorScheme: "none"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_paypal_js/* PayPalButtons */.ch, {
                    disabled: disabled,
                    //fundingSource={undefined}
                    fundingSource: "paypal",
                    style: {
                        layout: "vertical",
                        color: "blue",
                        label: "pay"
                    },
                    createOrder: function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(data, actions) {
                            var res;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            beforeCreateOrder()
                                        ];
                                    case 1:
                                        res = _state.sent();
                                        if (!res) return [
                                            2,
                                            ""
                                        ];
                                        return [
                                            2,
                                            actions.order.create({
                                                purchase_units: [
                                                    {
                                                        custom_id: customId,
                                                        invoice_id: invoiceId,
                                                        //description: "test description",
                                                        //reference_id: "reference 123",
                                                        amount: amount,
                                                        //amount: {
                                                        //  currency_code: "USD",
                                                        //  value: "0.01",
                                                        //},
                                                        items: items,
                                                        payee: {}
                                                    }
                                                ],
                                                application_context: {
                                                    shipping_preference: "NO_SHIPPING",
                                                    brand_name: "Moongate"
                                                }
                                            })
                                        ];
                                }
                            });
                        });
                        return function(data, actions) {
                            return _ref.apply(this, arguments);
                        };
                    }(),
                    onApprove: function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(data, actions) {
                            var ref, err, details;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            (0,utils.to)(actions.order.capture())
                                        ];
                                    case 1:
                                        ref = _state.sent(), err = ref.err, details = ref.res;
                                        if (err || !details) return [
                                            2,
                                            paypalCallback("error", err)
                                        ];
                                        paypalCallback("approve", details);
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(data, actions) {
                            return _ref.apply(this, arguments);
                        };
                    }(),
                    onError: function(error) {
                        paypalCallback("error", error);
                    },
                    onCancel: function(data) {
                        paypalCallback("cancel", data);
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var PayPalButtonWrapper_PayPalButtonWrapper = (PayPalButtonWrapper);

;// CONCATENATED MODULE: ./components/TicketingModal/CheckoutModal/CheckoutModal.tsx






























var FOLLOW_TWITTER_LINK = "https://twitter.com/intent/follow?original_referer=https%3A%2F%2Fwww.moongate.id%2F&ref_src=twsrc%5Etfw%7Ctwcamp%5Ebuttonembed%7Ctwterm%5Efollow%7Ctwgr%5E0xmoongate&screen_name=0xmoongate";
var WalletGroup = function(param) {
    var walletGroup = param.walletGroup;
    var networks = walletGroup.map(function(w) {
        return w.network;
    }).sort(function(a, b) {
        return a == network/* Network.ETHEREUM */.Zc.ETHEREUM ? -1 : 1 || 0;
    });
    var wallet = walletGroup[0];
    var address = wallet.address;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_dist_index_esm/* Radio */.Y8, {
        value: address,
        borderColor: "grey",
        border: "solid",
        colorScheme: "teal",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-row items-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cursor-pointer",
                    onClick: function() {
                        return navigator.clipboard.writeText(address);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_dist_index_esm/* Tooltip */.u, {
                        label: address,
                        children: (0,src_utils/* walletAddressPreview */.wC)(address)
                    })
                })
            })
        })
    });
};
var CheckoutModalItem = {
    title: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutModalTitle, {});
    },
    backButton: function(setModalItem) {
        return setModalItem(SelectTicketModalItem);
    },
    children: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutModalContent, {});
    }
};
var CheckoutModalTitle = function() {
    var t = (0,next_intl_cjs_production_min.useTranslations)("index");
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(checkoutFormLoadingAtom), 1), checkoutFormLoading = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: " flex flex-row justify-between items-center mr-auto flex-grow ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                className: "my-1",
                fontSize: "2xl",
                children: t("checkout")
            }),
            checkoutFormLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner_dist_index_esm/* Spinner */.$, {})
        ]
    });
};
//const CheckoutModalActionButton = () => {
//  return (
//    <></>
//  );
//};
//
// paypal, credit card, crypto
var PaymentMethods = [
    {
        name: "PayPal",
        active: true
    },
    {
        name: "Credit Card",
        active: false
    },
    {
        name: "Crypto",
        active: false
    }, 
];
var CheckoutModalContent = function() {
    var ref, ref1;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(openPaymentErrorModalAtom), 2), openDialog = ref2[0], setOpenDialog = ref2[1];
    var ref3 = (0,react.useState)((0,v4/* default */.Z)()), customId = ref3[0];
    var ref4 = (0,react.useState)((0,v4/* default */.Z)()), invoiceId = ref4[0];
    var elementRef = (0,react.useRef)(null);
    var twitterLinkRef = (0,react.useRef)(null);
    var dimensions = (0,hooks_dist_index_esm/* useDimensions */.Di)(elementRef, true);
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(successAtom), 2), setSuccess = ref5[1];
    var user = (0,auth/* useUserStore */.LM)(function(state) {
        return state.user;
    });
    var ref6 = (0,react.useState)(false), userEmailFirstTime = ref6[0], setUserEmailFirstTime = ref6[1];
    var ref7 = (0,react.useState)(false), claiming = ref7[0], setClaiming = ref7[1];
    var t = (0,next_intl_cjs_production_min.useTranslations)("checkout");
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,index_esm/* useMediaQuery */.ac)("(max-width: 768px)"), 1), isMobile = ref8[0];
    var size = isMobile ? "full" : "md";
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(selectedTicketAtom), 1), selectedTicket = ref9[0];
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(languageAtom), 1), lang = ref10[0];
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(checkoutFormLoadingAtom), 2), setCheckoutFormLoading = ref11[1];
    var ref12 = (0,react.useState)(false), isFollowed = ref12[0], setIsFollowed = ref12[1];
    var wallets = (0,react.useMemo)(function() {
        console.log(user);
        return (user === null || user === void 0 ? void 0 : user.getWalletsByNetwork(network/* Network.EVM */.Zc.EVM)) || [];
    }, [
        user
    ]);
    var walletGroups = (0,react.useMemo)(function() {
        return (0,lodash.groupBy)(wallets, function(wallet) {
            return wallet.address;
        }) || {};
    }, [
        wallets
    ]);
    var ref13 = (0,react_hook_form_dist_index_esm/* useForm */.cI)({
    }), register = ref13.register, formState = ref13.formState, watch = ref13.watch, setValue = ref13.setValue, trigger = ref13.trigger, control = ref13.control, getValues = ref13.getValues;
    var isValid = formState.isValid, errors = formState.errors, isValidating = formState.isValidating;
    (0,react.useEffect)(function() {
        setCheckoutFormLoading(isValidating);
    }, [
        formState
    ]);
    (0,react.useEffect)(function() {
        var prefillEmailAddress = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(user) {
                var transactions, isFirstTime;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                getTransactionByEmail(user.email)
                            ];
                        case 1:
                            transactions = _state.sent();
                            isFirstTime = transactions.length === 0;
                            setUserEmailFirstTime(isFirstTime);
                            if (isFirstTime) {
                                setValue("0-emailAddress", user.email);
                                setValue("0-confirmEmailAddress", user.email);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function prefillEmailAddress(user) {
                return _ref.apply(this, arguments);
            };
        }();
        if (user && user.email) {
            prefillEmailAddress(user);
        }
    }, [
        user
    ]);
    var handleDeveloperClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var recipient, ref, created, transaction, _transaction, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!selectedTicket || !user) return [
                            2
                        ];
                        setClaiming(true);
                        recipient = getValues("walletAddress") || "";
                        return [
                            4,
                            createTransaction(PaypalTransactionCaptureStatus.WAIVED, watch(), customId, invoiceId, selectedTicket, user, lang)
                        ];
                    case 1:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), created = ref[0], transaction = ref[1];
                        if (!created) return [
                            3,
                            10
                        ];
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            7,
                            8,
                            9
                        ]);
                        _transaction = new PaypalTransaction(transaction);
                        if (!selectedTicket.discount) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            markDiscount(selectedTicket.discount.id, selectedTicket.quantity)
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        // update ticket count
                        return [
                            4,
                            markTicket(selectedTicket.ticket, selectedTicket.quantity)
                        ];
                    case 5:
                        _state.sent();
                        mintNFT(recipient, _transaction);
                        return [
                            4,
                            sendEmailForTransaction(_transaction)
                        ];
                    case 6:
                        _state.sent();
                        setSuccess(true);
                        return [
                            3,
                            9
                        ];
                    case 7:
                        e = _state.sent();
                        console.error(e);
                        return [
                            3,
                            9
                        ];
                    case 8:
                        setClaiming(false);
                        return [
                            7
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        console.error("error while creating transaction");
                        setOpenDialog(true);
                        setClaiming(false);
                        _state.label = 11;
                    case 11:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDeveloperClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var beforeCreateOrder = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, created;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!selectedTicket || !user) return [
                            2
                        ];
                        return [
                            4,
                            createTransaction(PaypalTransactionCaptureStatus.INITIATED, watch(), customId, invoiceId, selectedTicket, user, lang)
                        ];
                    case 1:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            1
                        ]), created = ref[0];
                        return [
                            2,
                            created
                        ];
                }
            });
        });
        return function beforeCreateOrder() {
            return _ref.apply(this, arguments);
        };
    }();
    if (!selectedTicket) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "Loading..."
        });
    }
    var handleFollowClick = function() {
        setIsFollowed(true);
    };
    var handleFollowCheckboxChange = function(e) {
        if (twitterLinkRef.current) {
            e.preventDefault();
            (twitterLinkRef === null || twitterLinkRef === void 0 ? void 0 : twitterLinkRef.current).click();
            setIsFollowed(true);
        }
    };
    //let inputFile: any;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex p-4 md:p-12 gap-6 flex-col overflow-y-scroll w-full h-full bg-neutral-850",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                fontSize: "2xl",
                                fontWeight: 500,
                                my: "2rem",
                                children: t("contactInformation")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                fontSize: "md",
                                fontWeight: 500,
                                my: "2rem",
                                color: "neutral.200",
                                children: "Please fill out the form below to claim your NFT."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_dist_index_esm/* Accordion */.UQ, {
                                defaultIndex: [
                                    0
                                ],
                                allowMultiple: true,
                                children: (0,_to_consumable_array/* default */.Z)(Array(selectedTicket.quantity)).map(function(_, index, param) {
                                    var length = param.length;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutModal_ContactInformation, {
                                        attendee: index,
                                        register: register,
                                        errors: errors,
                                        selectedTicketType: selectedTicket.ticket.id,
                                        //validateEmail={validateEmail}
                                        watch: watch,
                                        isLast: index === length - 1,
                                        userEmailFirstTime: userEmailFirstTime,
                                        user: user,
                                        trigger: trigger
                                    }, index);
                                })
                            })
                        ]
                    }),
                    userEmailFirstTime && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                        fontSize: "2xl",
                                        fontWeight: 500,
                                        mt: "2rem",
                                        children: "Receiving Wallet"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                        fontSize: "md",
                                        fontWeight: 500,
                                        mt: "1rem",
                                        color: "neutral.200",
                                        children: "Please select a wallet that will be receiving the ticket NFT."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "px-1 ",
                                children: walletGroups && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_hook_form_dist_index_esm/* Controller */.Qr, {
                                    name: "walletAddress",
                                    control: control,
                                    rules: {
                                        required: true
                                    },
                                    defaultValue: (ref = wallets[0]) === null || ref === void 0 ? void 0 : ref.address,
                                    render: function(param) {
                                        var _field = param.field, onChange = _field.onChange, value = _field.value;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_dist_index_esm/* RadioGroup */.Ee, {
                                            onChange: onChange,
                                            value: value,
                                            display: "flex",
                                            flexDir: "column",
                                            gap: "1rem",
                                            children: Object.values(walletGroups).map(function(walletGroup, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(WalletGroup, {
                                                    walletGroup: walletGroup
                                                }, i);
                                            })
                                        });
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                        fontSize: "2xl",
                                        fontWeight: 500,
                                        mt: "2rem",
                                        children: "Acknowledgements"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                        fontSize: "md",
                                        fontWeight: 500,
                                        my: "1rem",
                                        color: "neutral.200",
                                        children: "Please read and acknowledge the following:"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_control_dist_index_esm/* FormControl */.NI, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormLabel */.lX, {
                                                htmlFor: "followTwitter",
                                                variant: "custom"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex flex-row items-center ",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(checkbox_dist_index_esm/* Checkbox */.XZ, {
                                                    type: "checkbox",
                                                    isChecked: isFollowed,
                                                    borderColor: "neutral.200",
                                                    colorScheme: "teal",
                                                    onChange: handleFollowCheckboxChange,
                                                    children: [
                                                        "* Follow us on \xa0",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            target: "_blank",
                                                            href: FOLLOW_TWITTER_LINK,
                                                            rel: "noopener noreferrer",
                                                            className: "underline text-primary-300",
                                                            onClick: handleFollowClick,
                                                            ref: twitterLinkRef,
                                                            children: "Twitter"
                                                        }),
                                                        "\xa0 to proceed. (Required)"
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_control_dist_index_esm/* FormControl */.NI, {
                                        isInvalid: Boolean(errors.agreement),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormLabel */.lX, {
                                                htmlFor: "agreement",
                                                variant: "custom"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_dist_index_esm/* Checkbox */.XZ, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                borderColor: "neutral.200",
                                                colorScheme: "teal",
                                                type: "checkbox"
                                            }, register("agreement", {
                                                required: "This field is required",
                                                onChange: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                                        switch(_state.label){
                                                            case 0:
                                                                return [
                                                                    4,
                                                                    trigger("agreement")
                                                                ];
                                                            case 1:
                                                                _state.sent();
                                                                return [
                                                                    2
                                                                ];
                                                        }
                                                    });
                                                })
                                            })), {
                                                children: t.rich("termAndCondition", {
                                                    termAndCond: function(children) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            target: "_blank",
                                                            href: "https://moongate.id/terms",
                                                            rel: "noopener noreferrer",
                                                            className: "underline text-primary-300",
                                                            children: children
                                                        });
                                                    },
                                                    privacyPolicy: function(children) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            target: "_blank",
                                                            href: "https://moongate.id/privacy",
                                                            rel: "noopener noreferrer",
                                                            className: "underline text-primary-300",
                                                            children: children
                                                        });
                                                    }
                                                })
                                            })),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormErrorMessage */.J1, {
                                                children: (ref1 = errors.agreement) === null || ref1 === void 0 ? void 0 : ref1.message
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    selectedTicket.payable > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                fontSize: "2xl",
                                fontWeight: 500,
                                mt: "2rem",
                                children: t("paymentMethod")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_dist_index_esm/* Accordion */.UQ, {
                                defaultIndex: [
                                    0
                                ],
                                children: PaymentMethods.map(function(paymentMethod, index, param) {
                                    var length = param.length;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(accordion_dist_index_esm/* AccordionItem */.Qd, {
                                        isDisabled: !paymentMethod.active,
                                        borderTop: 0,
                                        _last: {
                                            borderBottom: "0"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(accordion_dist_index_esm/* AccordionButton */.KF, {
                                                    _hover: {
                                                    },
                                                    bg: "neutral.900",
                                                    px: "1.25rem",
                                                    //borderTopRadius={!!attendee ? "" : "0.5rem"}
                                                    borderColor: "#DEDEE0",
                                                    borderWidth: "2px",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                                                            fontWeight: 500,
                                                            fontSize: "lg",
                                                            color: "neutral.300",
                                                            flex: "1",
                                                            textAlign: "left",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                                fontSize: "2xl",
                                                                fontWeight: 500,
                                                                my: "0.5rem",
                                                                children: paymentMethod.name
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_dist_index_esm/* AccordionIcon */.XE, {
                                                            width: "2rem",
                                                            fontSize: "2rem",
                                                            color: "neutral.300"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_dist_index_esm/* AccordionPanel */.Hk, {
                                                borderWidth: "2px",
                                                borderColor: "#DEDEE0",
                                                borderTop: 0,
                                                px: "1.25rem",
                                                py: "1rem",
                                                borderBottomRadius: index == length - 1 ? "0.5rem" : "",
                                                borderBottomWidth: index == length - 1 ? "2px" : "0",
                                                children: paymentMethod.name == "PayPal" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                            fontWeight: 500,
                                                            my: "0.875rem",
                                                            children: t("paymentNote")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PayPalButtonWrapper_PayPalButtonWrapper, {
                                                            disabled: !isValid,
                                                            items: selectedTicket.paypalItems,
                                                            amount: selectedTicket.paypalAmount,
                                                            customId: customId,
                                                            invoiceId: invoiceId,
                                                            beforeCreateOrder: beforeCreateOrder
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "my-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_dist_index_esm/* Button */.zx, {
                            disabled: !isValid || claiming,
                            onClick: handleDeveloperClick,
                            isLoading: claiming,
                            variant: "gradient",
                            children: [
                                " ",
                                t("claimTicket"),
                                " "
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog_Dialog, {
                isOpen: openDialog,
                size: size,
                onClose: function() {
                    return setOpenDialog(false);
                },
                icon: ic_blurred_bg_filled_red_cross,
                iconContainerStyles: "w-24 mb-4",
                title: t("paymentErrorTitle"),
                titleStyles: "text-2xl text-error font-semibold",
                minH: "413px",
                contentJustifyContent: "space-evenly",
                actions: [
                    {
                        text: t("tryAgain"),
                        textColor: "text-neutral-100",
                        primary: false,
                        error: true,
                        variant: "solid",
                        bgColor: "error",
                        onClick: function() {
                            setOpenDialog(false);
                        }
                    }, 
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-center text-white text-base font-medium ",
                    children: t("paymentErrorContent")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "md:hidden py-2 px-4 sm:p-4 flex flex-col w-full items-end bg-neutral-900 ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-row items-baseline",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-col items-end",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketingModal_TicketingModalExpandableButton, {})
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/TicketingModal/CheckoutModal/index.ts


;// CONCATENATED MODULE: ./components/TicketingModal/SelectTicketModal.tsx























var SelectTicketModalItem = {
    title: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketModalTitle, {});
    },
    children: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketModalContent, {});
    },
    actionButton: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketModalActionButton, {});
    }
};
var TicketModalTitle = function() {
    var t = (0,next_intl_cjs_production_min.useTranslations)("index");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "py-0 sm:py-0 flex flex-col items-center flex-grow-1",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
            className: "my-1",
            fontSize: "2xl ",
            textAlign: "center",
            children: t("ticketTitle")
        })
    });
};
var TicketModalActionButton = function() {
    var ref, ref1;
    var t = (0,next_intl_cjs_production_min.useTranslations)("index");
    var user = (0,auth/* useUserStore */.LM)(function(state) {
        return state.user;
    });
    var authenticating = (0,auth/* useUserStore */.LM)(function(state) {
        return state.authenticating;
    });
    var router = (0,next_router.useRouter)();
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(ticketingModalOpenAtom), 2), ticketingModal = ref2[0], setTicketingModal = ref2[1];
    var ref3 = (0,react.useState)(false), checkoutLoading = ref3[0], setCheckoutLoading = ref3[1];
    var ref4 = (0,react.useState)(false), signinModal = ref4[0], setSigninModal = ref4[1];
    var ref5 = (0,react.useState)(false), selected = ref5[0], setSelected = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(selectedTicketAtom), 2), selectedTicket = ref6[0], setSelectedTicket = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(ticketsAtom), 1), tickets = ref7[0];
    var ref8 = (0,react.useState)(""), val = ref8[0], setVal = ref8[1];
    var debouncedValue = (0,dist_esm/* useDebounce */.Nr)(val, 200);
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,index_esm/* useMediaQuery */.ac)("(max-width: 40rem)"), 1), isMobile = ref9[0];
    var ref10 = (0,react_hook_form_dist_index_esm/* useForm */.cI)({
    }), register = ref10.register, formState = ref10.formState, setError = ref10.setError, watch = ref10.watch, setValue = ref10.setValue, clearErrors = ref10.clearErrors, trigger = ref10.trigger;
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(ticketingModalItemAtom), 2), setModalItem = ref11[1];
    var errors = formState.errors, isValidating = formState.isValidating;
    (0,react.useEffect)(function() {
        if (selectedTicket) setSelected(true);
        console.log(selectedTicket);
        if (!selected) return;
        var query = selectedTicket ? (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
            checkout: "1",
            item: encodeURIComponent(selectedTicket.ticket.id),
            quantity: String(selectedTicket.quantity)
        }), selectedTicket.discount ? {
            code: encodeURIComponent(selectedTicket.discount.id)
        } : {}) : {};
        router.replace({
            pathname: router.pathname,
            query: query
        }, undefined, {
            shallow: true
        });
    }, [
        selectedTicket,
        selected,
        selectedTicket === null || selectedTicket === void 0 ? void 0 : selectedTicket.ticket.id,
        selectedTicket === null || selectedTicket === void 0 ? void 0 : selectedTicket.quantity,
        selectedTicket === null || selectedTicket === void 0 ? void 0 : (ref = selectedTicket.discount) === null || ref === void 0 ? void 0 : ref.id, 
    ]);
    var watchDiscountCode = watch("discountCode", "");
    (0,react.useEffect)(function() {
        // clear discount code when user changes ticket type
        if (!selectedTicket) {
            //setDiscountCode(undefined);
            setValue("discountCode", "");
            clearErrors("discountCode");
            setVal("");
        } else {
            if (selectedTicket.discount) {
                var ref;
                setValue("discountCode", ((ref = selectedTicket.discount) === null || ref === void 0 ? void 0 : ref.id) || "");
            }
        }
    }, [
        selectedTicket
    ]);
    (0,react.useEffect)(function() {
        console.log("debouncedValue", debouncedValue);
        if (!debouncedValue) {
            return;
        }
        var validateDiscount = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                validateDiscountCode(debouncedValue, selectedTicket, setSelectedTicket, tickets)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function validateDiscount() {
                return _ref.apply(this, arguments);
            };
        }();
        if (selectedTicket) {
            setCheckoutLoading(true);
            validateDiscount();
        }
    }, [
        debouncedValue
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (!watchDiscountCode) {
            clearErrors("discountCode");
            setVal("");
            setCheckoutLoading(false);
            return;
        }
        console.log("watchDiscountCode", errors, watchDiscountCode, debouncedValue);
        if (!(selectedTicket === null || selectedTicket === void 0 ? void 0 : (ref = selectedTicket.discount) === null || ref === void 0 ? void 0 : ref.isValid([
            selectedTicket.selectedTicketType
        ]))) {
            var ref1;
            setError("discountCode", {
                type: "manual",
                message: (selectedTicket === null || selectedTicket === void 0 ? void 0 : (ref1 = selectedTicket.discount) === null || ref1 === void 0 ? void 0 : ref1.invalidMessage([
                    selectedTicket.selectedTicketType, 
                ])) || "Invalid code"
            });
        } else {
            clearErrors("discountCode");
        }
        setCheckoutLoading(false);
    }, [
        watchDiscountCode,
        selectedTicket
    ]);
    var handleCheckout = function() {
        if (user) {
            setModalItem(CheckoutModalItem);
        } else {
            setSigninModal(true);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-4 py-2 sm:p-4 flex flex-col w-full items-end bg-neutral-900 border-t-2 border-solid border-[black]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row items-baseline",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "transition-opacity duration-500 ".concat(!selectedTicket && "opacity-0"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_control_dist_index_esm/* FormControl */.NI, {
                                isInvalid: Boolean(errors.discountCode),
                                mr: "1.5rem",
                                w: {
                                    md: "13rem"
                                },
                                children: [
                                    selectedTicket && /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, (0,_object_spread/* default */.Z)({
                                        fontSize: {
                                            base: "0.688rem",
                                            sm: "lg"
                                        },
                                        type: "text",
                                        placeholder: selectedTicket.ticket.redeemOnly && selectedTicket.freeTicketSelected ? t("enterRedeemCode") : t("enterDiscountCode")
                                    }, register("discountCode", {
                                        required: "",
                                        //validate: {
                                        //  checkDiscountCode: async (discountCode: string) =>
                                        //    (await validateDiscountCode(
                                        //      discountCode,
                                        //      selectedTicket,
                                        //      setSelectedTicket,
                                        //      tickets
                                        //    )) ||
                                        //    (selectedTicket?.freeTicketSelected
                                        //      ? t("incorrectRedeemCode")
                                        //      : t("incorrectDiscountCode")),
                                        //},
                                        onChange: function(e) {
                                            //await trigger("discountCode");
                                            setVal(e.target.value);
                                        }
                                    }))),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormErrorMessage */.J1, {
                                        children: !checkoutLoading && errors.discountCode && errors.discountCode.message
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-end py-1 sm:py-5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketingModal_TicketingModalExpandableButton, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                    variant: "gradient",
                                    disabled: !selectedTicket || selectedTicket.ticket.redeemOnly && selectedTicket.freeTicketWithInvalidDiscount || //(watchDiscountCode !== "" && !selectedTicket.discount) ||
                                    watchDiscountCode !== "" && !(selectedTicket === null || selectedTicket === void 0 ? void 0 : (ref1 = selectedTicket.discount) === null || ref1 === void 0 ? void 0 : ref1.isValid([
                                        selectedTicket.selectedTicketType, 
                                    ])),
                                    fontSize: "lg",
                                    px: "1.5rem",
                                    py: "0.70rem",
                                    fontWeight: "bold",
                                    onClick: handleCheckout,
                                    rightIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_dist_index_esm/* ArrowForwardIcon */.mr, {
                                        w: "1.5rem",
                                        h: "1.5rem"
                                    }),
                                    isLoading: checkoutLoading,
                                    children: "Next"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Modal */.u_, {
                isOpen: signinModal,
                onClose: function() {
                    return setSigninModal(false);
                },
                isCentered: true,
                variant: isMobile ? "full" : "auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* ModalOverlay */.ZA, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* ModalContent */.hz, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* ModalCloseButton */.ol, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* ModalBody */.fe, {
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(auth/* SignInModal */.fA, {})
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var returnMaxSelectForTicketId = function(ticketId, discountCode) {
    if (discountCode) {
        if (discountCode.remainingUses > 0) return discountCode.remainingUses;
    }
    switch(ticketId){
        // case TicketID.DEVELOPER:
        // case TicketID.SPONSOR:
        // case TicketID.MEDIA:
        // case TicketID.STAFF:
        // case TicketID.SPEAKER:
        // return 1;
        default:
            return 10;
    }
};
var TicketModalContent = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(selectedTicketAtom), 2), selectedTicket = ref[0], setSelectedTicket = ref[1];
    var t = (0,next_intl_cjs_production_min.useTranslations)("index");
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(ticketsAtom), 1), tickets = ref1[0];
    //const { setSelectedTickets, selectedTickets } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: tickets.length > 0 && concatSpecialTicket(tickets).map(function(tickets, index) {
            var ref;
            // non special tickets
            var ticketIds = tickets.map(function(t) {
                return t.id;
            });
            var disableTicket = selectedTicket && !ticketIds.includes(selectedTicket.ticket.id);
            var ticket = tickets[0];
            var discount = ticket.discount;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-6 flex-col text-neutral-100 ".concat(disableTicket && "text-opacity-50"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-4 flex-row items-start justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row items-center justify-start flex-wrap",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                fontSize: "2xl",
                                                mr: "1rem",
                                                color: "neutral.300",
                                                children: showConcatTicketName(t, tickets)
                                            }),
                                            discount && /*#__PURE__*/ (0,jsx_runtime.jsx)(tag_dist_index_esm/* Tag */.Vp, {
                                                bgColor: "primary.700",
                                                children: "".concat(t("priceSave"), " ").concat(discount.toFixed(0), "%")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "text-1xl text-neutral-300 ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-1xl ".concat(discount && "line-through"),
                                                children: ticket.defaultPrice ? "$".concat(ticket.defaultPrice.toFixed(0), " ").concat(CURRENCY) : "Invite Only"
                                            }),
                                            discount && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "text-1xl no-underline ",
                                                children: [
                                                    "\xa0",
                                                    ticket.currentPrice ? "$".concat(ticket.currentPrice.toFixed(0), " ").concat(CURRENCY) : t("free")
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HookUsage, {
                                disabled: disableTicket || ticket.remaining === 0,
                                handleValueChange: function(value) {
                                    return handleTicketQuantityChange(value, selectedTicket, setSelectedTicket, ticket);
                                },
                                value: selectedTicket && ticketIds.includes(selectedTicket === null || selectedTicket === void 0 ? void 0 : selectedTicket.ticket.id) ? selectedTicket === null || selectedTicket === void 0 ? void 0 : selectedTicket.quantity : 0
                            })
                        ]
                    }),
                    ((ref = returnTicketNotes(t).find(function(ticketNote) {
                        return ticketNote.ticketId === ticket.id;
                    })) === null || ref === void 0 ? void 0 : ref.note) || ticket.id,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Divider */.iz, {
                        background: "#A0A0A7"
                    })
                ]
            }, index);
        })
    });
};
var HookUsage = function(param) {
    var disabled = param.disabled, handleValueChange = param.handleValueChange, value = param.value;
    var ref = (0,number_input_dist_index_esm/* useNumberInput */.MM)({
        step: disabled ? 0 : 1,
        defaultValue: value,
        min: 0,
        max: 10,
        precision: 0
    }), getInputProps = ref.getInputProps, getIncrementButtonProps = ref.getIncrementButtonProps, getDecrementButtonProps = ref.getDecrementButtonProps;
    var inc = getIncrementButtonProps();
    var dec = getDecrementButtonProps();
    var input = getInputProps();
    (0,react.useEffect)(function() {
        handleValueChange(input.value);
    }, [
        input.value,
        value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* HStack */.Ug, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dec), {
                disabled: disabled,
                padding: "2px",
                minWidth: "2rem",
                fontSize: "1.5rem",
                color: "#FFFFFF",
                children: "-"
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                minW: "2rem",
                textAlign: "center",
                textColor: +input.value == 0 ? "neutral.600" : "neutral.300",
                children: input.value
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, inc), {
                disabled: disabled,
                padding: "2px",
                minWidth: "2rem",
                fontSize: "1.5rem",
                color: "#FFFFFF",
                children: "+"
            }))
        ]
    });
};
var handleTicketQuantityChange = function(v, selectedTicket, setSelectedTicket, ticket) {
    var selectedQuantity = +v;
    if (selectedQuantity > 0) {
        if (selectedTicket) {
            setSelectedTicket(new SelectedTicket({
                ticket: ticket,
                quantity: selectedQuantity || 0,
                discount: selectedTicket.discount
            }));
        } else {
            setSelectedTicket(new SelectedTicket({
                ticket: ticket,
                quantity: selectedQuantity || 0
            }));
        }
    } else {
        setSelectedTicket(null);
    }
};

;// CONCATENATED MODULE: ./utils/atoms/index.ts


var successAtom = (0,esm/* atom */.cn)(false);
var languageAtom = (0,esm/* atom */.cn)("en");
var emailModalAtom = (0,esm/* atom */.cn)(false);
var ticketingModalOpenAtom = (0,esm/* atom */.cn)(false);
var orderSummaryOpenAtom = (0,esm/* atom */.cn)(false);
var ticketsAtom = (0,esm/* atom */.cn)([]);
var selectedTicketAtom = (0,esm/* atom */.cn)(null);
var checkoutFormLoadingAtom = (0,esm/* atom */.cn)(false);
var ticketingModalItemAtom = (0,esm/* atom */.cn)(SelectTicketModalItem);
var openPaymentErrorModalAtom = (0,esm/* atom */.cn)(false);

;// CONCATENATED MODULE: ./components/EmailModal/EmailModal.tsx















var validateAndUpdateEmail = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(emailAddress, userId) {
        var config, res, err;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    config = {
                        method: "post",
                        url: "/api/users/".concat(userId, "/email"),
                        data: {
                            email: transformEmailAddr(emailAddress)
                        }
                    };
                    return [
                        4,
                        (0,axios/* default */.ZP)(config)
                    ];
                case 1:
                    res = _state.sent();
                    //const res: { [index: string]: any } = await new Promise(resolve => {
                    //  setTimeout(() => resolve({ status: 200, data: { success: true } }), 1000);
                    //});
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    err = _state.sent();
                    //console.log(err);
                    return [
                        2,
                        err.response.data
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function validateAndUpdateEmail(emailAddress, userId) {
        return _ref.apply(this, arguments);
    };
}();
var EmailModal = function(param) {
    var t = param.t;
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,index_esm/* useMediaQuery */.ac)("(max-width: 768px)"), 1), isMobile = ref1[0];
    var size = isMobile ? "full" : "md";
    var user = (0,auth/* useUserStore */.LM)(function(state) {
        return state.user;
    });
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(emailModalAtom), 2), emailModal = ref2[0], setEmailModal = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(ticketingModalOpenAtom), 2), setTicketingModal = ref3[1];
    var ref4 = (0,react_hook_form_dist_index_esm/* useForm */.cI)(), handleSubmit = ref4.handleSubmit, register = ref4.register, _formState = ref4.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting, setError = ref4.setError;
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
            var result, ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!user) {
                            console.error("user not found");
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            validateAndUpdateEmail(values.emailAddress, user.id)
                        ];
                    case 1:
                        result = _state.sent();
                        //console.log("validateAndUpdateEmail result", result);
                        if (result.success) {
                            user.email = values.emailAddress;
                            user.identifiers = (0,utils/* unique */.Tw)((0,_to_consumable_array/* default */.Z)(user.identifiers).concat([
                                user.email
                            ]));
                            auth/* useUserStore.setState */.LM.setState({
                                user: user
                            });
                            //console.log(user);
                            setEmailModal(false);
                            return [
                                2,
                                setTicketingModal(true)
                            ];
                        }
                        switch(result.error){
                            case src_user/* UserError.EMAIL_INUSE */.gK.EMAIL_INUSE:
                                setError("emailAddress", {
                                    type: "invalid",
                                    message: t("emailRegistered")
                                });
                                break;
                            default:
                                ;
                                console.error("unknown error: ", (ref = result.error) === null || ref === void 0 ? void 0 : ref.code);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Modal */.u_, {
        size: size,
        isOpen: emailModal,
        onClose: function() {
            return setEmailModal(false);
        },
        isCentered: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* ModalOverlay */.ZA, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* ModalContent */.hz, {
                py: "5rem",
                px: "3.75rem",
                h: {
                    sm: "28rem"
                },
                minWidth: {
                    sm: "40rem"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* ModalCloseButton */.ol, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-col items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Text */.xv, {
                                    fontSize: "4xl",
                                    children: [
                                        " ",
                                        t("oneMoreStep")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                    fontSize: "md",
                                    color: "neutral.300",
                                    children: t("connectEmail")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        className: "flex flex-col my-8",
                        onSubmit: handleSubmit(onSubmit),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_control_dist_index_esm/* FormControl */.NI, {
                                isInvalid: Boolean(errors["emailAddress"]),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormLabel */.lX, {
                                        htmlFor: "emailAddress",
                                        variant: "custom",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-primary-200",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: t("emailAddress")
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, (0,_object_spread/* default */.Z)({
                                        type: "text",
                                        placeholder: "example@gmail.com"
                                    }, register("emailAddress", {
                                        required: "".concat(t("emailAddress"), " ").concat(t("required")),
                                        pattern: {
                                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                            message: t("invalidEmail")
                                        }
                                    }))),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormErrorMessage */.J1, {
                                        children: (ref = errors["emailAddress"]) === null || ref === void 0 ? void 0 : ref.message
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                mt: 8,
                                h: "3.5rem",
                                colorScheme: "teal",
                                isLoading: isSubmitting,
                                type: "submit",
                                children: t("signIn")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var EmailModal_EmailModal = (EmailModal);

// EXTERNAL MODULE: ../node_modules/@chakra-ui/system/dist/index.esm.js + 4 modules
var system_dist_index_esm = __webpack_require__(4777);
// EXTERNAL MODULE: ../node_modules/@chakra-ui/color-mode/dist/index.esm.js
var color_mode_dist_index_esm = __webpack_require__(354);
// EXTERNAL MODULE: ../node_modules/@chakra-ui/visually-hidden/dist/index.esm.js
var visually_hidden_dist_index_esm = __webpack_require__(7760);
// EXTERNAL MODULE: ../node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(7228);
;// CONCATENATED MODULE: ./public/images/logo.svg
/* harmony default export */ var logo = ({"src":"/_next/static/media/logo.e88d95f2.svg","height":254,"width":1646});
;// CONCATENATED MODULE: ./components/Footer/Footer.tsx






var SocialButton = function(param) {
    var children = param.children, label = param.label, href = param.href;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(system_dist_index_esm/* chakra.button */.m$.button, {
        //bg={useColorModeValue('blackAlpha.100', 'whiteAlpha.100')}
        //rounded={'full'}
        w: 8,
        h: 8,
        cursor: "pointer",
        as: "a",
        href: href,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "background 0.3s ease",
        _hover: {
            bg: (0,color_mode_dist_index_esm/* useColorModeValue */.ff)("blackAlpha.200", "whiteAlpha.200")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(visually_hidden_dist_index_esm/* VisuallyHidden */.TX, {
                children: label
            }),
            children
        ]
    });
};
var ListHeader = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
        fontWeight: "500",
        fontSize: "1rem",
        mb: 7,
        color: "white",
        children: children
    });
};
var LinkWrap = function(param) {
    var children = param.children, href = param.href;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Link */.rU, {
        href: href,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
            mb: 6,
            fontWeight: 500,
            color: "white",
            fontSize: "lg",
            children: children
        })
    });
};
function LargeWithNewsletter() {
    var t = (0,next_intl_cjs_production_min.useTranslations)("footer");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
        bg: "neutral.850",
        color: (0,color_mode_dist_index_esm/* useColorModeValue */.ff)("gray.700", "gray.200"),
        borderTop: "2px solid #010613",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Container */.W2, {
            as: layout_dist_index_esm/* Stack */.Kq,
            maxW: "6xl",
            py: 14,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* SimpleGrid */.MI, {
                templateColumns: {
                    base: "1fr",
                    sm: "1fr 1fr"
                },
                spacing: 8,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Stack */.Kq, {
                        spacing: 6,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://moongate.id",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-48 cursor-pointer svg-black",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: logo,
                                            alt: "moongate"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                fontSize: "sm",
                                fontWeight: 600,
                                color: "#010613",
                                children: "Empowering the Next Generation of Tickets & Memberships."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Stack */.Kq, {
                        align: "flex-start",
                        spacing: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Stack */.Kq, {
                            direction: {
                                base: "column",
                                md: "row"
                            },
                            spacing: {
                                base: 0,
                                md: 7
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Stack */.Kq, {
                                    direction: "row",
                                    spacing: 7,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListHeader, {
                                            children: "Contact us"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrap, {
                                            href: "https://themoongate.notion.site/Moongate-FAQs-ffbb9d4ba5084b8abf5a46829c923486",
                                            children: "FAQ"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrap, {
                                            href: "https://moongate.id/terms",
                                            children: "Terms"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrap, {
                                            href: "https://moongate.id/privacy",
                                            children: "Privacy"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Show */.di, {
                                    above: "sm",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListHeader, {
                                        children: "|"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Stack */.Kq, {
                                    direction: "row",
                                    spacing: 7,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialButton, {
                                            label: "Twitter",
                                            href: "https://twitter.com/0xmoongate",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaTwitter */.fWC, {
                                                size: "1.5rem",
                                                color: "#010613"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialButton, {
                                            label: "Instagram",
                                            href: "https://www.instagram.com/0xmoongate/",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaInstagram */.Zf_, {
                                                size: "1.5rem",
                                                color: "#010613"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialButton, {
                                            label: "YouTube",
                                            href: "https://discord.com/invite/KpvCUD5NgM",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaDiscord */.j2d, {
                                                size: "1.5rem",
                                                color: "#010613"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ../node_modules/@chakra-ui/icon/dist/index.esm.js
var _chakra_ui_icon_dist_index_esm = __webpack_require__(7484);
// EXTERNAL MODULE: ../node_modules/@chakra-ui/popover/dist/index.esm.js + 4 modules
var popover_dist_index_esm = __webpack_require__(4376);
// EXTERNAL MODULE: ../node_modules/@chakra-ui/transition/dist/index.esm.js
var transition_dist_index_esm = __webpack_require__(5162);
// EXTERNAL MODULE: ../node_modules/react-icons/ri/index.esm.js
var ri_index_esm = __webpack_require__(2312);
;// CONCATENATED MODULE: ./components/LandingNavBar/LandingNavBar.tsx










function WithSubnavigation() {
    var user = (0,auth/* useUserStore */.LM)(function(state) {
        return state.user;
    });
    var ref = (0,hooks_dist_index_esm/* useDisclosure */.qY)(), isOpen = ref.isOpen, onToggle = ref.onToggle;
    var copyWallet = function() {
        navigator.clipboard.writeText((user === null || user === void 0 ? void 0 : user.getWalletsByNetwork(network/* Network.POLYGON */.Zc.POLYGON)[0].address) || "");
    };
    var mobileNavCollapseDisplay = isOpen ? "max-h-[500px]" : "max-h-0";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
        borderBottom: "2px solid #010613",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, {
                shadow: "base",
                //bg={'neutral.850'}
                bg: "background",
                justify: "space-between",
                align: "center",
                color: (0,color_mode_dist_index_esm/* useColorModeValue */.ff)("gray.600", "white"),
                minH: "110px",
                py: {
                    base: 4
                },
                px: {
                    base: 8,
                    md: 16
                },
                //borderBottom={1}
                borderStyle: "solid",
                borderColor: (0,color_mode_dist_index_esm/* useColorModeValue */.ff)("gray.200", "gray.900"),
                flexWrap: "nowrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Link */.rU, {
                        href: "/",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-48 sm:w-64 cursor-pointer svg-black ",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: logo,
                                alt: "moongate"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Flex */.kC, {
                        display: {
                            base: "none",
                            md: "flex"
                        },
                        padding: "1rem",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopNav, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, {
                        display: {
                            base: "none",
                            md: "flex"
                        },
                        flex: 0,
                        justify: "flex-end",
                        direction: "row",
                        alignItems: "center",
                        minW: "auto",
                        children: [
                            user ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col mr-1 justify-center items-center text-xs",
                                        children: [
                                            user.email && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "mb-1",
                                                children: user.email
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_dist_index_esm/* Tooltip */.u, {
                                                label: user.getWalletsByNetwork(network/* Network.POLYGON */.Zc.POLYGON)[0].address,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "bg-neutral-800 py-1 px-4 rounded-full cursor-pointer text-xs",
                                                    onClick: copyWallet,
                                                    children: user.getWalletsByNetwork(network/* Network.POLYGON */.Zc.POLYGON)[0].addressPreview
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
                                        onClick: function() {
                                            return (0,auth/* logOut */.ni)();
                                        },
                                        "aria-label": "log out",
                                        variant: "ghost",
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(_chakra_ui_icon_dist_index_esm/* Icon */.JO, {
                                            as: ri_index_esm/* RiLogoutBoxRLine */.Opj,
                                            w: 5,
                                            h: 5,
                                            color: "white"
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                variant: "gradient",
                                py: 3,
                                marginLeft: 4,
                                onClick: function() {
                                    return window.open("https://app.moongate.id", "_blank", "noopener,noreferrer");
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Launch App"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Flex */.kC, {
                        flex: {
                            base: 1,
                            md: 0
                        },
                        display: {
                            base: "flex",
                            md: "none"
                        },
                        justify: "flex-end",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
                            onClick: onToggle,
                            icon: isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_dist_index_esm/* CloseIcon */.Tw, {
                                w: 3,
                                h: 3,
                                color: "white"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_dist_index_esm/* HamburgerIcon */.Uq, {
                                w: 5,
                                h: 5,
                                color: "white"
                            }),
                            variant: "ghost",
                            "aria-label": "Toggle Navigation"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                //className={`${mobileNavCollapseDisplay} overflow-hidden transition-[max-height] duration-500 ease-out`}
                className: "".concat(mobileNavCollapseDisplay, " overflow-hidden "),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileNav, {})
            })
        ]
    });
}
var DesktopNav = function() {
    var linkColor = (0,color_mode_dist_index_esm/* useColorModeValue */.ff)("gray.600", "gray.200");
    var linkHoverColor = (0,color_mode_dist_index_esm/* useColorModeValue */.ff)("gray.800", "white");
    var popoverContentBgColor = (0,color_mode_dist_index_esm/* useColorModeValue */.ff)("white", "gray.800");
    var t = (0,next_intl_cjs_production_min.useTranslations)("index");
    var navItems = [];
    var _href, _target;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Stack */.Kq, {
        direction: "row",
        spacing: 4,
        alignItems: "center",
        children: navItems.map(function(navItem) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover_dist_index_esm/* Popover */.J2, {
                    trigger: "hover",
                    placement: "bottom-start",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverTrigger */.xo, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Link */.rU, {
                                p: 2,
                                href: (_href = navItem.href) !== null && _href !== void 0 ? _href : "#",
                                target: (_target = navItem.target) !== null && _target !== void 0 ? _target : "_self",
                                fontSize: "0.9rem",
                                fontWeight: 500,
                                color: linkColor,
                                _hover: {
                                    textDecoration: "none",
                                    color: linkHoverColor
                                },
                                children: navItem.label
                            })
                        }),
                        navItem.children && /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverContent */.yk, {
                            border: 0,
                            boxShadow: "xl",
                            bg: popoverContentBgColor,
                            p: 4,
                            rounded: "xl",
                            minW: "sm",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Stack */.Kq, {
                                children: navItem.children.map(function(child) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopSubNav, (0,_object_spread/* default */.Z)({}, child), child.label);
                                })
                            })
                        })
                    ]
                })
            }, navItem.label);
        })
    });
};
var DesktopSubNav = function(param) {
    var label = param.label, href = param.href, subLabel = param.subLabel, target = param.target;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Link */.rU, {
        href: href,
        target: target !== null && target !== void 0 ? target : "_self",
        role: "group",
        display: "block",
        p: 2,
        rounded: "md",
        _hover: {
            bg: (0,color_mode_dist_index_esm/* useColorModeValue */.ff)("pink.50", "gray.900")
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Stack */.Kq, {
            direction: "row",
            align: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                            transition: "all .3s ease",
                            _groupHover: {
                                color: "pink.400"
                            },
                            fontWeight: 500,
                            children: label
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                            fontSize: "sm",
                            children: subLabel
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Flex */.kC, {
                    transition: "all .3s ease",
                    transform: "translateX(-10px)",
                    opacity: 0,
                    _groupHover: {
                        opacity: "100%",
                        transform: "translateX(0)"
                    },
                    justify: "flex-end",
                    align: "center",
                    flex: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(_chakra_ui_icon_dist_index_esm/* Icon */.JO, {
                        color: "pink.400",
                        w: 5,
                        h: 5
                    })
                })
            ]
        })
    });
};
var MobileNav = function() {
    var t = (0,next_intl_cjs_production_min.useTranslations)("index");
    var user = (0,auth/* useUserStore */.LM)(function(state) {
        return state.user;
    });
    var navItems = [];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Stack */.Kq, {
        //bg={useColorModeValue("white", "gray.800")}
        bg: "background",
        display: {
            md: "none"
        },
        spacing: 4,
        children: [
            navItems.map(function(navItem) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileNavItem, (0,_object_spread/* default */.Z)({}, navItem), navItem.label);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full flex justify-center pb-4 ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                    variant: "gradient",
                    className: "flex flex-row justify-center items-center self-center font-semibold",
                    onClick: function() {
                        return window.open("https://app.moongate.id", "_blank", "noopener,noreferrer");
                    },
                    children: "Launch App"
                })
            }),
            user && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pb-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "flex flex-row justify-center items-center font-semibold",
                    onClick: function() {
                        return (0,auth/* logOut */.ni)();
                    },
                    children: t("logout")
                })
            })
        ]
    });
};
var MobileNavItem = function(param) {
    var label = param.label, children = param.children, href = param.href, target = param.target;
    var ref = (0,hooks_dist_index_esm/* useDisclosure */.qY)(), isOpen = ref.isOpen, onToggle = ref.onToggle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Stack */.Kq, {
        spacing: 4,
        onClick: children && onToggle,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, {
                py: 2,
                as: layout_dist_index_esm/* Link */.rU,
                href: href !== null && href !== void 0 ? href : "#",
                target: target !== null && target !== void 0 ? target : "_self",
                justify: "center",
                align: "center",
                _hover: {
                    textDecoration: "none"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                        fontWeight: 600,
                        color: (0,color_mode_dist_index_esm/* useColorModeValue */.ff)("gray.600", "gray.200"),
                        children: label
                    }),
                    children && /*#__PURE__*/ (0,jsx_runtime.jsx)(_chakra_ui_icon_dist_index_esm/* Icon */.JO, {
                        //as={ChevronDownIcon}
                        transition: "all .25s ease-in-out",
                        transform: isOpen ? "rotate(180deg)" : "",
                        w: 6,
                        h: 6
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition_dist_index_esm/* Collapse */.UO, {
                in: isOpen,
                animateOpacity: true,
                style: {
                    marginTop: "0!important"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Stack */.Kq, {
                    mt: 2,
                    pl: 4,
                    borderLeft: 1,
                    borderStyle: "solid",
                    borderColor: (0,color_mode_dist_index_esm/* useColorModeValue */.ff)("gray.200", "gray.700"),
                    align: "center",
                    justify: "center",
                    children: children && children.map(function(child) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: child.href,
                            target: "_blank",
                            rel: "noreferrer",
                            children: child.label
                        }, child.href);
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./public/images/ticket.svg
/* harmony default export */ var ticket = ({"src":"/_next/static/media/ticket.62a5908e.svg","height":64,"width":60});
;// CONCATENATED MODULE: ./components/TicketingModal/TicketingModalOrderSummary.tsx









var OrderSummary = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(selectedTicketAtom), 1), selectedTicket = ref[0];
    var t = (0,next_intl_cjs_production_min.useTranslations)("index");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col flex-grow justify-start items-center p-4 bg-neutral-900 border-l-[0.5px] border-neutral-600 rounded",
        children: [
            selectedTicket ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col flex-grow w-full justify-start items-start p-[1.875rem] gap-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Text */.xv, {
                        fontSize: "lg",
                        fontWeight: 600,
                        children: [
                            t("orderSummary"),
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-lg font-medium flex flex-row justify-between w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex-shrink",
                                        children: [
                                            "".concat(selectedTicket.quantity, " x ").concat(t("".concat(selectedTicket.ticket.id)), " "),
                                            selectedTicket.ticket.discount && /*#__PURE__*/ (0,jsx_runtime.jsx)(tag_dist_index_esm/* Tag */.Vp, {
                                                bgColor: "primary.700",
                                                children: "".concat(t("priceSave"), " ").concat(selectedTicket.discountTagToFixed, "%")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex-shrink-0",
                                        children: selectedTicket.total ? "$ ".concat(selectedTicket.totalToFixed, " ").concat(CURRENCY) : "Free"
                                    })
                                ]
                            }),
                            (selectedTicket === null || selectedTicket === void 0 ? void 0 : selectedTicket.discount) && selectedTicket.totalDiscount !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-lg font-medium flex flex-row justify-between w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex-shrink",
                                        children: "Promo Discount"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex-shrink-0",
                                        children: "- $ ".concat((selectedTicket === null || selectedTicket === void 0 ? void 0 : selectedTicket.totalDiscount).toFixed(2), " ").concat(CURRENCY)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row justify-between w-full text-2xl",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                        fontSize: "medium",
                                        children: " Sub-total "
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                        fontSize: "medium",
                                        children: selectedTicket.total ? "$ ".concat(selectedTicket === null || selectedTicket === void 0 ? void 0 : selectedTicket.payableToFixed, " ").concat(CURRENCY) : "Free"
                                    })
                                ]
                            }),
                            selectedTicket.total !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-lg text-sm flex flex-row justify-between w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex-shrink",
                                        children: [
                                            "Transaction fee (",
                                            selectedTicket.transactionFeePct,
                                            "%)"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex-shrink-0",
                                        children: "+ $ ".concat((selectedTicket === null || selectedTicket === void 0 ? void 0 : selectedTicket.transactionFee).toFixed(2), " ").concat(CURRENCY)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Divider */.iz, {
                                background: "#A0A0A7"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row justify-between w-full text-2xl",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Text */.xv, {
                                        children: [
                                            " ",
                                            t("total"),
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                        children: selectedTicket.total ? "$ ".concat(selectedTicket === null || selectedTicket === void 0 ? void 0 : selectedTicket.totalPlusTxnFeeToFixed, " ").concat(CURRENCY) : "Free"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-auto flex flex-col justify-center items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-10 svg-black",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            layout: "responsive",
                            src: ticket,
                            alt: "hide"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                        className: "my-1 ",
                        fontSize: "2md",
                        children: t("noOrder")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-auto self-end"
            })
        ]
    });
};
/* harmony default export */ var TicketingModalOrderSummary = (OrderSummary);

;// CONCATENATED MODULE: ./public/images/tbw-banner/checkout-page.png
/* harmony default export */ var checkout_page = ({"src":"/_next/static/media/checkout-page.08224401.png","height":800,"width":1020,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAFVBMVEUJFi0CCR4IESYCHDYILEoNOV0VIzu8zNwbAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAKUlEQVQImQ3LtwEAMAzDMKr5/5MT7EACbHC3xgfddhilbXIIknBYkn94DOgAdTPPIDEAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/images/astra/full.png
/* harmony default export */ var full = ({"src":"/_next/static/media/full.f7dfc173.png","height":361,"width":454,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAFVBMVEUCEQsACAUGHRICKxwANCMbMR8mVjDiJ04tAAAABnRSTlP+/v79/f6WiFA4AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAKElEQVQImRWIQQ4AAAiCUKv/P7l5YQDJzCQmFyQqt0jG8q4N/WXR0AMMzABcvrJZ9gAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/images/astra/corporate.png
/* harmony default export */ var corporate = ({"src":"/_next/static/media/corporate.4d23b2b4.png","height":288,"width":360,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAJ1BMVEUIBQLf4N/Y2dk9OzcyMTAUEAvPz8/T1NS7vLuzs7NfWlJHRkMfGxUw9hg9AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAMElEQVQImRXJxw3AMBAEsdm9pOD+6zX0I0BGsiyhE5EZi/koYNNF1cPcfLWxWz3uHxLDAMHrCE19AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/images/astra/founding.png
/* harmony default export */ var founding = ({"src":"/_next/static/media/founding.3276e399.png","height":288,"width":360,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAADFBMVEUnJyghICAyMjMWFRU7ItaJAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAJUlEQVQImSXHwREAMBCCQND+e86Y47WQCyLQQkrCP4OD2Hba6AMG9wA5tr0M0wAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./components/PaymentSuccess/PaymentSuccess.tsx













var PaymentSuccess = function() {
    var t = (0,next_intl_cjs_production_min.useTranslations)("paymentSuccess");
    var ref = (0,_sliced_to_array/* default */.Z)((0,index_esm/* useMediaQuery */.ac)("(max-width: 768px)"), 1), isMobile = ref[0];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(selectedTicketAtom), 2), selectedTicket = ref1[0], setSelectedTicket = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col justify-center items-center p-4 sm:py-16 sm:flex-row-reverse relative p-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-[0%] max-w-[510px] md:flex bg-neutral-800 md:w-[42.5%] flex-col hidden sm:mx-16",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: " overflow-hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: checkout_page,
                            alt: "Astra Club"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketingModalOrderSummary, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-center h-full rounded-3xl overflow-hidden w-full sm:items-start sm:ml-16 sm:max-w-max",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "p-4 flex-col flex sm:items-start items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-lg sm:text-3xl text-center font-medium mt-10 text-neutral-300",
                                children: "Congrats, thanks for your order! \uD83C\uDF89"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-4xl sm:text-5xl font-bold max-w-xl py-8 sm:py-10 sm:pt-20",
                                children: "The Astra Club"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Text */.xv, {
                                color: "neutral.300",
                                fontSize: "lg",
                                mb: [
                                    "",
                                    "3rem"
                                ],
                                maxW: "75ch",
                                textAlign: [
                                    "center",
                                    "left"
                                ],
                                children: [
                                    "An exclusive club created to reward our closest partners, friends, and early adopters of Moongate. By invitation only.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "Join our \xa0",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-primary font-bold",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            href: "https://discord.com/invite/KpvCUD5NgM",
                                            rel: "noopener noreferrer",
                                            children: "Discord"
                                        })
                                    }),
                                    "\xa0 server and follow us on \xa0",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-primary font-bold",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            href: "https://twitter.com/0xmoongate",
                                            rel: "noopener noreferrer",
                                            children: "Twitter"
                                        })
                                    }),
                                    "\xa0 to learn more about upcoming drops and requirements!"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-col flex items-center sm:flex-row sm:items-start gap-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex-col flex items-center p-4 sm:items-start gap-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-secondary text-base font-semibold text-neutral-300",
                                        children: "YOUR CLAIMED NFT(S)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "rounded-xl overflow-hidden w-[227px] ",
                                        children: [
                                            (selectedTicket === null || selectedTicket === void 0 ? void 0 : selectedTicket.ticket.id) === TicketID.FULL && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: full,
                                                alt: "Astra Club Full"
                                            }),
                                            (selectedTicket === null || selectedTicket === void 0 ? void 0 : selectedTicket.ticket.id) === TicketID.FOUNDING && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: founding,
                                                alt: "Astra Club founding"
                                            }),
                                            (selectedTicket === null || selectedTicket === void 0 ? void 0 : selectedTicket.ticket.id) === TicketID.CORPORATE && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: corporate,
                                                alt: "Astra Club corporate"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-text-primary text-base font-medium text-neutral-600"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col items-center justify-evenly sm:gap-8 w-full relative sm:ml-[8.25rem]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col items-center gap-1 w-full p-4 text-center sm:items-start",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-secondary text-base font-semibold text-neutral-300",
                                                children: t("location")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-text-primary text-base font-medium text-neutral-600",
                                                children: "The Astra Club"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col items-center gap-1 w-full p-4 text-center sm:items-start",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-secondary text-base font-semibold text-neutral-300",
                                                children: t("dateTime")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-text-primary text-base font-medium text-neutral-600",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: "Working Hours 16:00 - 03:00"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "w-fit",
                        href: "https://app.moongate.id",
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                            variant: "gradient",
                            marginBottom: [
                                "2rem",
                                "1rem"
                            ],
                            marginTop: [
                                "2rem",
                                "4rem"
                            ],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "See My NFT"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PaymentSuccess_PaymentSuccess = (PaymentSuccess);

;// CONCATENATED MODULE: ./public/images/tbw-banner/event-detail-page.png
/* harmony default export */ var event_detail_page = ({"src":"/_next/static/media/event-detail-page.f5227d88.png","height":800,"width":1020,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAFVBMVEUIEicCCR4HFy4ILEoCHDcNOV0UIjmjBGDXAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAKklEQVQImR3Gxw0AMBDDMLmc9x85QPgikgEMuUvZzw1Qk7RDtlsPJCHvAQwQAHgCtaKYAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./components/TicketBannerSection/TicketBannerSection.tsx



var TicketBannerSection = function(param) {
    var t = param.t, loading = param.loading, buyTicket = param.buyTicket;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col w-full max-w-[500px] ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                style: {
                    borderRadius: "0.25rem 0.25rem 0 0"
                },
                src: event_detail_page,
                alt: "Avax park"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-row "
            })
        ]
    });
};
/* harmony default export */ var TicketBannerSection_TicketBannerSection = (TicketBannerSection);

;// CONCATENATED MODULE: ./public/images/back-button.svg
/* harmony default export */ var back_button = ({"src":"/_next/static/media/back-button.541d09be.svg","height":48,"width":48});
;// CONCATENATED MODULE: ./components/TicketingModal/TicketingModal.tsx











var TicketingModal = function() {
    var ref;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(successAtom), 1), success = ref1[0];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(ticketingModalOpenAtom), 2), ticketingModal = ref2[0], setTicketingModal = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(orderSummaryOpenAtom), 2), orderSummaryOpen = ref3[0], setOrderSummaryOpen = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(ticketingModalItemAtom), 2), modalItem = ref4[0], setModalItem = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,index_esm/* useMediaQuery */.ac)("(max-width: 768px)"), 1), isMobile = ref5[0];
    var size = isMobile ? "full" : "md";
    var variant = isMobile ? "full" : "custom";
    var _onClose = function() {
        setTicketingModal(false);
        router.push({
            pathname: router.pathname
        }, undefined, {
            shallow: true
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Modal */.u_, {
        isOpen: ticketingModal && !success,
        onClose: _onClose,
        isCentered: true,
        size: size,
        variant: variant,
        scrollBehavior: "inside",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* ModalOverlay */.ZA, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* ModalContent */.hz, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* ModalCloseButton */.ol, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row items-stretch flex-grow h-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col items-center w-full md:w-[67.5%] h-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row w-full items-center justify-center bg-neutral-900 p-4 sm:p-2 border-b-2 border-solid border-[black]",
                                        children: [
                                            (modalItem === null || modalItem === void 0 ? void 0 : modalItem.backButton) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex-grow mr-auto",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "w-10 mr-auto flex-grow-0 svg-black",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: back_button,
                                                        layout: "responsive",
                                                        alt: "back",
                                                        onClick: function() {
                                                            var ref;
                                                            return modalItem === null || modalItem === void 0 ? void 0 : (ref = modalItem.backButton) === null || ref === void 0 ? void 0 : ref.call(modalItem, setModalItem);
                                                        }
                                                    })
                                                })
                                            }),
                                            modalItem === null || modalItem === void 0 ? void 0 : modalItem.title()
                                        ]
                                    }),
                                    (modalItem === null || modalItem === void 0 ? void 0 : modalItem.actionButton) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex p-4 md:p-12 gap-6 flex-col overflow-y-scroll w-full h-full bg-neutral-850",
                                                children: modalItem === null || modalItem === void 0 ? void 0 : modalItem.children()
                                            }),
                                            modalItem === null || modalItem === void 0 ? void 0 : (ref = modalItem.actionButton) === null || ref === void 0 ? void 0 : ref.call(modalItem)
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: modalItem === null || modalItem === void 0 ? void 0 : modalItem.children()
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-[0%] md:flex bg-neutral-800 md:w-[42.5%] flex-col overflow-hidden",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: checkout_page,
                                        alt: "Astra Club",
                                        objectFit: "cover"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketingModalOrderSummary, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Drawer */.dy, {
                        placement: "bottom",
                        onClose: function() {
                            return setOrderSummaryOpen(false);
                        },
                        isOpen: orderSummaryOpen,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* DrawerOverlay */.P1, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* DrawerContent */.sc, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex flex-row justify-end bg-neutral-700 p-3",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_dist_index_esm/* ChevronDownIcon */.v4, {
                                            onClick: function() {
                                                return setOrderSummaryOpen(false);
                                            },
                                            w: 8,
                                            h: 8
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* DrawerBody */.Ng, {
                                        minH: "70vh",
                                        bg: "neutral.700",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketingModalOrderSummary, {})
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TicketingModal_TicketingModal = (TicketingModal);

// EXTERNAL MODULE: ../node_modules/next/head.js
var head = __webpack_require__(8038);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./pages/index.tsx























var Index = function(param) {
    var locale = param.locale;
    var t = (0,next_intl_cjs_production_min.useTranslations)("index");
    var router = (0,next_router.useRouter)();
    var user = (0,auth/* useUserStore */.LM)(function(state) {
        return state.user;
    });
    var authenticating = (0,auth/* useUserStore */.LM)(function(state) {
        return state.authenticating;
    });
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(languageAtom), 2), setLang = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(emailModalAtom), 2), setEmailModal = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(ticketingModalOpenAtom), 2), modalOpen = ref2[0], setTicketingModal = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(selectedTicketAtom), 2), selectedTicket = ref3[0], setSelectedTicket = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(ticketsAtom), 2), setTickets = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(successAtom), 1), success = ref5[0];
    var ref6 = (0,useQuery/* useQuery */.a)([
        "tickets"
    ], function() {
        return getTickets();
    }), tickets = ref6.data, isLoading = ref6.isLoading;
    (0,react.useEffect)(function() {
        setLang(locale);
    }, [
        locale
    ]);
    (0,react.useEffect)(function() {
        if (!user || !tickets || !router.isReady || !router.query.checkout || !router.query.item || !router.query.quantity) return;
        var ticketId = decodeURIComponent(String(router.query.item));
        var ticket = tickets.find(function(t) {
            return t.id == ticketId;
        });
        if (!ticket) return;
        setTicketingModal(true);
        var quantity = parseInt(decodeURIComponent(String(router.query.quantity)));
        var discountCode = router.query.code ? decodeURIComponent(String(router.query.code)) : undefined;
        var selectedTicket = new SelectedTicket({
            ticket: ticket,
            quantity: quantity
        });
        console.log("setSelectedTicket by query", selectedTicket);
        setSelectedTicket(selectedTicket);
        if (discountCode) {
            validateDiscountCode(discountCode, selectedTicket, setSelectedTicket, tickets);
        }
    }, [
        user,
        tickets,
        router.isReady,
        router.query.checkout,
        router.query.item,
        router.query.quantity,
        router.query.code, 
    ]);
    (0,react.useEffect)(function() {
        if (tickets) setTickets(tickets);
    }, [
        tickets
    ]);
    var total = (0,react.useMemo)(function() {
        return (tickets || []).reduce(function(acc, ticket) {
            return acc + ticket.total - ticket.sold;
        }, 0);
    }, [
        tickets
    ]);
    var buyTicket = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    setTicketingModal(true)
                ];
            });
        });
        return function buyTicket() {
            return _ref.apply(this, arguments);
        };
    }();
    if (authenticating || !tickets) return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingPage/* default */.Z, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: t("title")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-background w-screen relative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col min-h-screen items-stretch bg-center bg-cover bg-no-repeat bg-[url('/images/auth-bg.svg')]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "sticky top-0 w-full self-center z-10",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WithSubnavigation, {})
                        }),
                        success ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentSuccess_PaymentSuccess, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full md:max-w-7xl m-auto flex flex-col p-6 md:pt-16 md:flex-row md:flex-auto items-start justify-end md:items-start md:justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketBannerSection_TicketBannerSection, {
                                    t: t,
                                    loading: authenticating,
                                    buyTicket: buyTicket
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col items-start w-full md:w-1/2 md:pl-16 md:pr-8 ",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-4xl md:text-5xl font-bold max-w-xl py-8 md:pb-10 md:py-0",
                                            children: "The Astra Club"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Divider */.iz, {
                                            background: "#A0A0A7"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Text */.xv, {
                                            color: "neutral.300",
                                            fontSize: "lg",
                                            my: "3rem",
                                            maxW: "75ch",
                                            children: [
                                                "An exclusive club created to reward our closest partners, friends, and early adopters of Moongate. By invitation only.",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "Join our \xa0",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-primary font-bold",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        target: "_blank",
                                                        href: "https://discord.com/invite/KpvCUD5NgM",
                                                        rel: "noopener noreferrer",
                                                        children: "Discord"
                                                    })
                                                }),
                                                "\xa0 server and follow us on \xa0",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-primary font-bold",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        target: "_blank",
                                                        href: "https://twitter.com/0xmoongate",
                                                        rel: "noopener noreferrer",
                                                        children: "Twitter"
                                                    })
                                                }),
                                                "\xa0 to learn more about upcoming drops and requirements!"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Divider */.iz, {
                                            background: "#A0A0A7"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                            color: "neutral.300",
                                            fontSize: "lg",
                                            mt: "2.25rem",
                                            mb: "1.25rem",
                                            children: "Received an invitation? Enter below to claim your membership."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                            variant: "gradient",
                                            flexBasis: 0,
                                            flexGrow: 1,
                                            borderRadius: "0.25rem",
                                            py: "4",
                                            fontWeight: 600,
                                            fontSize: "1rem",
                                            onClick: buyTicket,
                                            display: "flex",
                                            flexDir: "row",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            disabled: authenticating,
                                            isLoading: authenticating,
                                            width: "100%",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: "Claim Now"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "my-8 md:my-16 w-full",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                fontSize: "2xl",
                                                fontWeight: 600
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LargeWithNewsletter, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketingModal_TicketingModal, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailModal_EmailModal, {
                t: t
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var pages = (Index);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [357,969,871,527,774,888,179], function() { return __webpack_exec__(9536); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);